import React, { useState, useEffect, useRef } from 'react';
import { 
  LayoutDashboard, FilePlus2, PackageSearch, Users, 
  Settings, Ship, Search, UserCircle, 
  MapPin, Calendar, Car, ArrowRight, CheckCircle2,
  X, Download, Edit, Save, ChevronLeft, ChevronRight,
  Printer, Lock, LogOut, Eye, EyeOff, Trash2, AlertCircle, Route, Plus, Shield, RefreshCw, Info, Copy, ClipboardCheck
} from 'lucide-react';

const GOOGLE_APPS_SCRIPT_CODE = `// ==================== KODE GOOGLE APPS SCRIPT UNTUK ANTAROTO ====================
// Silakan salin semua kode ini ke Apps Script Anda

const databaseSheets = {
  orders: "Orders",
  customers: "Customers",
  routes: "Routes"
};

function doGet(e) {
  return ContentService.createTextOutput(JSON.stringify({ status: "success", message: "AntarOto API is online" }))
    .setMimeType(ContentService.MimeType.JSON);
}

function doPost(e) {
  try {
    const requestData = JSON.parse(e.postData.contents);
    const action = requestData.action;
    const data = requestData.data;
    
    const spreadsheet = SpreadsheetApp.getActiveSpreadsheet();
    initializeSheets(spreadsheet);

    if (action === "readAll") {
      return createJsonResponse({
        status: "success",
        orders: readFromSheet(spreadsheet, databaseSheets.orders),
        customers: readFromSheet(spreadsheet, databaseSheets.customers),
        routes: readFromSheet(spreadsheet, databaseSheets.routes)
      });
    }

    if (action === "addOrder") {
      writeToSheet(spreadsheet, databaseSheets.orders, data);
      updateCustomerStats(spreadsheet, data.sender, data.ktp, data.whatsapp);
      return createJsonResponse({ status: "success" });
    }

    if (action === "updateOrder") {
      updateInSheet(spreadsheet, databaseSheets.orders, "id", data.id, data);
      return createJsonResponse({ status: "success" });
    }

    if (action === "deleteOrder") {
      deleteFromSheet(spreadsheet, databaseSheets.orders, "id", data.id);
      return createJsonResponse({ status: "success" });
    }

    if (action === "addRoute") {
      writeToSheet(spreadsheet, databaseSheets.routes, data);
      return createJsonResponse({ status: "success" });
    }

    if (action === "updateRoute") {
      updateInSheet(spreadsheet, databaseSheets.routes, "id", data.id, data);
      return createJsonResponse({ status: "success" });
    }

    if (action === "deleteRoute") {
      deleteFromSheet(spreadsheet, databaseSheets.routes, "id", data.id);
      return createJsonResponse({ status: "success" });
    }

    if (action === "updateCustomer") {
      updateInSheet(spreadsheet, databaseSheets.customers, "id", data.id, data);
      return createJsonResponse({ status: "success" });
    }

    if (action === "deleteCustomer") {
      deleteFromSheet(spreadsheet, databaseSheets.customers, "id", data.id);
      return createJsonResponse({ status: "success" });
    }

    if (action === "addBatchRoutes") {
      const sheet = spreadsheet.getSheetByName(databaseSheets.routes);
      // Bersihkan kecuali header
      if (sheet.getLastRow() > 1) {
        sheet.deleteRows(2, sheet.getLastRow() - 1);
      }
      data.forEach(function(route) {
        writeToSheet(spreadsheet, databaseSheets.routes, route);
      });
      return createJsonResponse({ status: "success" });
    }

    return createJsonResponse({ status: "error", message: "Action not recognized" });

  } catch (error) {
    return createJsonResponse({ status: "error", message: error.toString() });
  }
}

function initializeSheets(spreadsheet) {
  Object.keys(databaseSheets).forEach(function(key) {
    const sheetName = databaseSheets[key];
    let sheet = spreadsheet.getSheetByName(sheetName);
    if (!sheet) {
      sheet = spreadsheet.insertSheet(sheetName);
      let headers = [];
      if (sheetName === databaseSheets.orders) {
        headers = ["id", "sender", "ktp", "whatsapp", "receiverName", "receiverWhatsapp", "receiverAddress", "vehicle", "vehicleColor", "vehiclePlate", "vehicleYear", "vehicleClass", "vehicleNotes", "route", "origin", "dest", "status", "entryDate", "shipDate", "price", "insurance", "doorToDoor", "notes", "paymentStatus"];
      } else if (sheetName === databaseSheets.customers) {
        headers = ["id", "name", "ktp", "whatsapp", "totalOrders"];
      } else if (sheetName === databaseSheets.routes) {
        headers = ["id", "origin", "dest", "vehicleClass", "price"];
      }
      sheet.appendRow(headers);
    }
  });
}

function readFromSheet(spreadsheet, sheetName) {
  const sheet = spreadsheet.getSheetByName(sheetName);
  const rows = sheet.getDataRange().getValues();
  if (rows.length <= 1) return [];
  
  const headers = rows[0];
  const items = [];
  
  for (let i = 1; i < rows.length; i++) {
    const row = rows[i];
    const item = {};
    headers.forEach(function(header, colIndex) {
      let value = row[colIndex];
      if (value === "true") value = true;
      if (value === "false") value = false;
      item[header] = value;
    });
    items.push(item);
  }
  return items;
}

function writeToSheet(spreadsheet, sheetName, dataObject) {
  const sheet = spreadsheet.getSheetByName(sheetName);
  const headers = sheet.getValues()[0] || sheet.getRange(1, 1, 1, sheet.getLastColumn()).getValues()[0];
  const newRow = headers.map(function(header) {
    return dataObject[header] !== undefined ? dataObject[header] : "";
  });
  sheet.appendRow(newRow);
}

function updateInSheet(spreadsheet, sheetName, idKey, idValue, updatedData) {
  const sheet = spreadsheet.getSheetByName(sheetName);
  const rows = sheet.getDataRange().getValues();
  const headers = rows[0];
  const idColIndex = headers.indexOf(idKey);
  
  if (idColIndex === -1) return;
  
  for (let i = 1; i < rows.length; i++) {
    if (String(rows[i][idColIndex]) === String(idValue)) {
      const rowNum = i + 1;
      headers.forEach(function(header, colIndex) {
        if (updatedData[header] !== undefined) {
          sheet.getRange(rowNum, colIndex + 1).setValue(updatedData[header]);
        }
      });
      break;
    }
  }
}

function deleteFromSheet(spreadsheet, sheetName, idKey, idValue) {
  const sheet = spreadsheet.getSheetByName(sheetName);
  const rows = sheet.getDataRange().getValues();
  const headers = rows[0];
  const idColIndex = headers.indexOf(idKey);
  
  if (idColIndex === -1) return;
  
  for (let i = 1; i < rows.length; i++) {
    if (String(rows[i][idColIndex]) === String(idValue)) {
      sheet.deleteRow(i + 1);
      break;
    }
  }
}

function updateCustomerStats(spreadsheet, name, ktp, whatsapp) {
  if (!name || name === "-") return;
  const sheet = spreadsheet.getSheetByName(databaseSheets.customers);
  const rows = sheet.getDataRange().getValues();
  const headers = rows[0];
  
  const nameCol = headers.indexOf("name");
  const waCol = headers.indexOf("whatsapp");
  const countCol = headers.indexOf("totalOrders");
  
  let found = false;
  for (let i = 1; i < rows.length; i++) {
    const rowName = String(rows[i][nameCol]).toLowerCase();
    const rowWa = String(rows[i][waCol]);
    
    if (rowName === name.toLowerCase() || (whatsapp && rowWa === whatsapp)) {
      const currentCount = Number(rows[i][countCol]) || 0;
      sheet.getRange(i + 1, countCol + 1).setValue(currentCount + 1);
      found = true;
      break;
    }
  }
  
  if (!found) {
    const nextIdNum = rows.length;
    const formattedId = "CUST-" + (nextIdNum < 10 ? "00" + nextIdNum : nextIdNum < 100 ? "0" + nextIdNum : nextIdNum);
    writeToSheet(spreadsheet, databaseSheets.customers, {
      id: formattedId,
      name: name,
      ktp: ktp || "-",
      whatsapp: whatsapp || "-",
      totalOrders: 1
    });
  }
}

function createJsonResponse(obj) {
  return ContentService.createTextOutput(JSON.stringify(obj))
    .setMimeType(ContentService.MimeType.JSON);
}`;

const LoginScreen = ({ onLogin, externalError }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      onLogin(username, password);
    }, 1200);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 font-sans select-none animate-in fade-in duration-300">
      <div className="sm:mx-auto sm:w-full sm:max-w-md px-4">
        
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <div className="bg-blue-600 p-3.5 rounded-2xl text-white shadow-xl shadow-blue-100 flex items-center justify-center">
            <Ship size={32} strokeWidth={2.5} />
          </div>
        </div>
        
        <h2 className="text-center text-3xl font-black text-slate-900 tracking-tight">
          AntarOto
        </h2>
        <p className="mt-1.5 text-center text-sm text-slate-500 font-medium">
          Portal Administrasi & Operasional Sistem
        </p>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow-md rounded-2xl sm:px-10 border border-slate-100">
            <form className="space-y-5" onSubmit={handleLogin}>
              
              {externalError && (
                <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-xl text-xs font-semibold flex items-center gap-2 animate-in slide-in-from-top-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-500 shrink-0"></span>
                  {externalError}
                </div>
              )}

              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">
                  Username
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                    <UserCircle size={18} className="text-slate-400" />
                  </div>
                  <input
                    type="text"
                    required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="appearance-none block w-full pl-11 pr-4 py-3.5 border border-slate-200 rounded-xl bg-slate-50/50 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white transition-all text-sm font-medium text-slate-800"
                    placeholder="Masukkan username..."
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">
                  Kata Sandi
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                    <Lock size={18} className="text-slate-400" />
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="appearance-none block w-full pl-11 pr-12 py-3.5 border border-slate-200 rounded-xl bg-slate-50/50 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white transition-all text-sm font-medium text-slate-800"
                    placeholder="••••••••"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-400 hover:text-slate-600 transition-colors"
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-between pt-1">
                <div className="flex items-center">
                  <input
                    id="remember-me"
                    type="checkbox"
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-slate-300 rounded-lg cursor-pointer transition-colors"
                  />
                  <label htmlFor="remember-me" className="ml-2 block text-xs font-semibold text-slate-600 cursor-pointer select-none">
                    Ingat Sesi Saya
                  </label>
                </div>
              </div>

              <div className="pt-2">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-xl shadow-md shadow-blue-100 text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all disabled:opacity-60 active:scale-[0.99]"
                >
                  {isLoading ? (
                    <div className="flex items-center gap-2">
                      <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Memverifikasi...
                    </div>
                  ) : 'Masuk ke Dashboard'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem('antaroto_user');
  });
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [generatedResi, setGeneratedResi] = useState('');
  const [searchQuery, setSearchQuery] = useState(''); 
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isCopiedScript, setIsCopiedScript] = useState(false);

  // --- GOOGLE SHEETS SYNC STATE ---
  const [googleScriptUrl, setGoogleScriptUrl] = useState(() => {
    return localStorage.getItem('antaroto_sheets_url') || '';
  });
  const [tempUrlInput, setTempUrlInput] = useState(googleScriptUrl);
  const [isSyncing, setIsSyncing] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState('offline'); // 'offline' | 'connecting' | 'online'
  
  // Custom Toast Notification System
  const [toast, setToast] = useState(null);
  
  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 4000);
  };

  const mainContentRef = useRef(null);

  // --- STATE AKUN PENGGUNA ---
  const [usersList, setUsersList] = useState([
    { id: 'USR-001', username: 'admin', password: '3ti_In0nk@82', name: 'Iman Firdaus', role: 'Super Admin' },
    { id: 'USR-002', username: 'operator1', password: 'opie123', name: 'M. Taufik', role: 'Admin Operasional' },
  ]);
  const [currentUser, setCurrentUser] = useState(() => {
    const savedUser = localStorage.getItem('antaroto_user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [loginError, setLoginError] = useState('');
  
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [userFormData, setUserFormData] = useState({ id: '', username: '', password: '', name: '', role: 'Admin Operasional' });
  const [isDeleteUserModalOpen, setIsDeleteUserModalOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  // --- STATE DATABASE UTAMA (KOSONG BY DEFAULT) ---
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [routeList, setRouteList] = useState([]);

  const loadSimulationData = () => {
    const dummyOrders = [
      { 
        id: 'AO-2606-001', sender: 'Budi Santoso', ktp: '3171012345678001', whatsapp: '08123456789',
        receiverName: 'Andi Wijaya', receiverWhatsapp: '081311112222', receiverAddress: 'Jl. Boulevard No. 12, Makassar',
        vehicle: 'Innova', vehicleColor: 'Silver', vehiclePlate: 'B 1234 ABC', vehicleYear: '2021', vehicleClass: 'Golongan IV (Mobil Penumpang/Pribadi <= 5m)', vehicleNotes: 'Kondisi mulus',
        route: 'JKT - MKS', origin: 'Tanjung Priok, Jakarta', dest: 'Soekarno-Hatta, Makassar', 
        status: 'Menunggu', entryDate: '2026-06-10', shipDate: '2026-06-15', 
        price: 4000000, insurance: true, doorToDoor: true, notes: '', paymentStatus: 'Belum' 
      },
      { 
        id: 'AO-2606-002', sender: 'PT Maju Jaya', ktp: '-', whatsapp: '08119876543',
        receiverName: 'Bapak Roni', receiverWhatsapp: '085244445555', receiverAddress: 'Pelabuhan Semayang, Balikpapan',
        vehicle: 'Triton', vehicleColor: 'Hitam', vehiclePlate: 'L 9876 XX', vehicleYear: '2020', vehicleClass: 'Golongan V (Truk/Bus Sedang <= 7m)', vehicleNotes: 'Ada goresan di bak belakang',
        route: 'SBY - BPN', origin: 'Tanjung Perak, Surabaya', dest: 'Semayang, Balikpapan', 
        status: 'Proses Muat', entryDate: '2026-06-09', shipDate: '2026-06-12', 
        price: 3800000, insurance: false, doorToDoor: false, notes: '', paymentStatus: 'Lunas' 
      },
      { 
        id: 'AO-2606-003', sender: 'Andi Wijaya', ktp: '3171019876543002', whatsapp: '081311112222',
        receiverName: 'Budi Santoso', receiverWhatsapp: '08123456789', receiverAddress: 'Tanjung Priok, Jakarta',
        vehicle: 'HR-V', vehicleColor: 'Putih', vehiclePlate: 'KT 4321 AA', vehicleYear: '2022', vehicleClass: 'Golongan IV (Mobil Penumpang/Pribadi <= 5m)', vehicleNotes: 'Mulus baru keluar dealer',
        route: 'BPN - JKT', origin: 'Semayang, Balikpapan', dest: 'Tanjung Priok, Jakarta', 
        status: 'Dalam Perjalanan', entryDate: '2026-06-05', shipDate: '2026-06-08', 
        price: 3600000, insurance: true, doorToDoor: false, notes: 'Telat 1 hari krn cuaca', paymentStatus: 'Belum' 
      },
    ];

    const dummyCustomers = [
      { id: 'CUST-001', name: 'Budi Santoso', ktp: '3171012345678001', whatsapp: '08123456789', totalOrders: 1 },
      { id: 'CUST-002', name: 'PT Maju Jaya', ktp: '-', whatsapp: '08119876543', totalOrders: 1 },
      { id: 'CUST-003', name: 'Andi Wijaya', ktp: '3171019876543002', whatsapp: '081311112222', totalOrders: 1 }
    ];

    const dummyRoutes = [
      { id: 'RT-001', origin: 'Tanjung Priok, Jakarta', dest: 'Soekarno-Hatta, Makassar', vehicleClass: 'Golongan I (Sepeda / Roda Dua Kecil)', price: 750000 },
      { id: 'RT-002', origin: 'Tanjung Priok, Jakarta', dest: 'Soekarno-Hatta, Makassar', vehicleClass: 'Golongan II (Sepeda Motor < 500cc)', price: 1200000 },
      { id: 'RT-003', origin: 'Tanjung Priok, Jakarta', dest: 'Soekarno-Hatta, Makassar', vehicleClass: 'Golongan IV (Mobil Penumpang/Pribadi <= 5m)', price: 4000000 },
      { id: 'RT-004', origin: 'Tanjung Priok, Jakarta', dest: 'Soekarno-Hatta, Makassar', vehicleClass: 'Golongan V (Truk/Bus Sedang <= 7m)', price: 6500000 },
      { id: 'RT-005', origin: 'Tanjung Perak, Surabaya', dest: 'Semayang, Balikpapan', vehicleClass: 'Golongan IV (Mobil Penumpang/Pribadi <= 5m)', price: 3200000 },
      { id: 'RT-006', origin: 'Tanjung Perak, Surabaya', dest: 'Semayang, Balikpapan', vehicleClass: 'Golongan V (Truk/Bus Sedang <= 7m)', price: 3800000 },
      { id: 'RT-007', origin: 'Semayang, Balikpapan', dest: 'Tanjung Priok, Jakarta', vehicleClass: 'Golongan IV (Mobil Penumpang/Pribadi <= 5m)', price: 3600000 }
    ];

    setOrders(dummyOrders);
    setCustomers(dummyCustomers);
    setRouteList(dummyRoutes);
    showToast("Data simulasi multi-tarif berhasil dimuat!", "info");
  };

  const handleSeedStandardRoutes = async () => {
    if (!googleScriptUrl) {
      showToast("Harap sambungkan URL Google Sheets terlebih dahulu di menu Pengaturan!", "error");
      return;
    }
    setIsSubmitting(true);
    showToast("Memulai sinkronisasi & seeding 84 rute...", "info");

    const portsList = [
      "Tanjung Priok, Jakarta",
      "Tanjung Perak, Surabaya",
      "Soekarno-Hatta, Makassar",
      "Semayang, Balikpapan"
    ];

    const classesList = [
      "Golongan I (Sepeda / Roda Dua Kecil)",
      "Golongan II (Sepeda Motor < 500cc)",
      "Golongan III (Sepeda Motor >= 500cc)",
      "Golongan IV (Mobil Penumpang/Pribadi <= 5m)",
      "Golongan V (Truk/Bus Sedang <= 7m)",
      "Golongan VI (Truk/Bus Besar <= 10m)",
      "Golongan VII (Truk Tronton/Trailer > 10m)"
    ];

    const baseRates = {
      "Tanjung Priok, Jakarta-Tanjung Perak, Surabaya": 2500000,
      "Tanjung Perak, Surabaya-Tanjung Priok, Jakarta": 2500000,
      "Tanjung Priok, Jakarta-Soekarno-Hatta, Makassar": 4000000,
      "Soekarno-Hatta, Makassar-Tanjung Priok, Jakarta": 4000000,
      "Tanjung Priok, Jakarta-Semayang, Balikpapan": 3800000,
      "Semayang, Balikpapan-Tanjung Priok, Jakarta": 3800000,
      "Tanjung Perak, Surabaya-Soekarno-Hatta, Makassar": 3500000,
      "Soekarno-Hatta, Makassar-Tanjung Perak, Surabaya": 3500000,
      "Tanjung Perak, Surabaya-Semayang, Balikpapan": 3200000,
      "Semayang, Balikpapan-Tanjung Perak, Surabaya": 3200000,
      "Soekarno-Hatta, Makassar-Semayang, Balikpapan": 4200000,
      "Semayang, Balikpapan-Soekarno-Hatta, Makassar": 4200000
    };

    const modifiers = {
      "Golongan I (Sepeda / Roda Dua Kecil)": 0.15,
      "Golongan II (Sepeda Motor < 500cc)": 0.3,
      "Golongan III (Sepeda Motor >= 500cc)": 0.5,
      "Golongan IV (Mobil Penumpang/Pribadi <= 5m)": 1.0,
      "Golongan V (Truk/Bus Sedang <= 7m)": 1.5,
      "Golongan VI (Truk/Bus Besar <= 10m)": 2.2,
      "Golongan VII (Truk Tronton/Trailer > 10m)": 3.0
    };

    const generatedRoutesToSeed = [];
    let idCounter = 1;

    for (const origin of portsList) {
      for (const dest of portsList) {
        if (origin === dest) continue;
        const key = `${origin}-${dest}`;
        const baseRate = baseRates[key] || 3500000;

        for (const vClass of classesList) {
          const calculatedPrice = Math.round((baseRate * (modifiers[vClass] || 1.0)) / 50000) * 50000;
          const formattedId = idCounter < 10 ? `00${idCounter}` : idCounter < 100 ? `0${idCounter}` : idCounter;
          
          generatedRoutesToSeed.push({
            id: `RT-${formattedId}`,
            origin,
            dest,
            vehicleClass: vClass,
            price: calculatedPrice
          });
          idCounter++;
        }
      }
    }

    try {
      const response = await requestSync('addBatchRoutes', generatedRoutesToSeed);
      if (response && response.status === 'success') {
        showToast("Seeding berhasil! 84 Tarif Golongan Standar tersimpan di Google Sheet Anda.", "success");
        await loadDataFromSheets();
      } else {
        showToast("Gagal mengirim data seeding ke Google Sheet.", "error");
      }
    } catch (err) {
      showToast("Gagal melakukan sinkronisasi database: " + err.message, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const requestSync = async (action, data) => {
    if (!googleScriptUrl) return null;
    try {
      const response = await fetch(googleScriptUrl, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8'
        },
        body: JSON.stringify({ action, data })
      });
      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Gagal melakukan sinkronisasi:", error);
      showToast("Kesalahan sinkronisasi ke Google Sheet: " + error.message, "error");
      throw error;
    }
  };

  const loadDataFromSheets = async (targetUrl = googleScriptUrl) => {
    if (!targetUrl) {
      setConnectionStatus('offline');
      return;
    }
    setConnectionStatus('connecting');
    setIsSyncing(true);
    try {
      const res = await fetch(targetUrl);
      const test = await res.json();
      if (test.status === 'success') {
        const rawResponse = await fetch(targetUrl, {
          method: 'POST',
          body: JSON.stringify({ action: 'readAll' })
        });
        const result = await rawResponse.json();
        
        if (result.status === 'success') {
          const formattedOrders = (result.orders || []).map((o) => ({
            ...o,
            insurance: o.insurance === true || o.insurance === 'true',
            doorToDoor: o.doorToDoor === true || o.doorToDoor === 'true',
            price: Number(o.price) || 0
          }));
          const formattedCustomers = (result.customers || []).map((c) => ({
            ...c,
            totalOrders: Number(c.totalOrders) || 0
          }));
          const formattedRoutes = (result.routes || []).map((r) => ({
            ...r,
            price: Number(r.price) || 0
          }));

          setOrders(formattedOrders);
          setCustomers(formattedCustomers);
          setRouteList(formattedRoutes);
          
          setConnectionStatus('online');
          showToast("Semua database disinkronkan dengan Google Sheets!", "success");
        } else {
          setConnectionStatus('offline');
          showToast("Aplikasi Script merespons error saat memuat data.", "error");
        }
      }
    } catch (err) {
      setConnectionStatus('offline');
      showToast("Gagal terhubung ke Google Sheet. Periksa kembali URL Web App.", "error");
    } finally {
      setIsSyncing(false);
    }
  };

  useEffect(() => {
    if (googleScriptUrl) {
      loadDataFromSheets(googleScriptUrl);
    }
  }, [googleScriptUrl]);

  const saveUrlConfiguration = (e) => {
    e.preventDefault();
    localStorage.setItem('antaroto_sheets_url', tempUrlInput);
    setGoogleScriptUrl(tempUrlInput);
    if (!tempUrlInput) {
      setOrders([]);
      setCustomers([]);
      setRouteList([]);
      setConnectionStatus('offline');
      showToast("URL Google Sheet dihapus. Kembali ke mode luring.", "info");
    }
  };

  const handleLoginAttempt = (username, password) => {
    const user = usersList.find(u => u.username === username && u.password === password);
    if (user) {
      setCurrentUser(user);
      setIsAuthenticated(true);
      setLoginError('');
      localStorage.setItem('antaroto_user', JSON.stringify(user));
    } else {
      setLoginError('Username atau kata sandi salah!');
    }
  };

  const handleUserInputChange = (e) => setUserFormData({ ...userFormData, [e.target.name]: e.target.value });

  const saveUser = (e) => {
    e.preventDefault();
    if (userFormData.id) {
      setUsersList(usersList.map(u => u.id === userFormData.id ? userFormData : u));
    } else {
      const nextIdNum = usersList.length + 1;
      const formattedIdNum = nextIdNum < 10 ? `00${nextIdNum}` : nextIdNum < 100 ? `0${nextIdNum}` : nextIdNum;
      setUsersList([...usersList, { ...userFormData, id: `USR-${formattedIdNum}` }]);
    }
    setIsUserModalOpen(false);
    showToast("Pengguna berhasil disimpan!");
  };

  const openAddUserModal = () => {
    setUserFormData({ id: '', username: '', password: '', name: '', role: 'Admin Operasional' });
    setIsUserModalOpen(true);
  };
  
  const openEditUserModal = (user) => {
    setUserFormData({ ...user });
    setIsUserModalOpen(true);
  };

  const openDeleteUserModal = (user) => {
    setUserToDelete(user);
    setIsDeleteUserModalOpen(true);
  };

  const confirmDeleteUser = () => {
    if (userToDelete) {
      setUsersList(usersList.filter(u => u.id !== userToDelete.id));
      setIsDeleteUserModalOpen(false);
      setUserToDelete(null);
      showToast("Pengguna berhasil dihapus!");
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setActiveMenu('dashboard');
    setCurrentUser(null);
    setSearchQuery('');
    localStorage.removeItem('antaroto_user');
  };

  const changeMenu = (menu) => {
    setActiveMenu(menu);
    setSearchQuery(''); 
    if (mainContentRef.current) {
      mainContentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // --- STATE FORMS & MODALS ---
  const [isEditCustomerModalOpen, setIsEditCustomerModalOpen] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [isDeleteCustomerModalOpen, setIsDeleteCustomerModalOpen] = useState(false);
  const [customerToDelete, setCustomerToDelete] = useState(null);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingOrder, setEditingOrder] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState(null);

  const [isRouteModalOpen, setIsRouteModalOpen] = useState(false);
  const [routeFormData, setRouteFormData] = useState({ id: '', origin: '', dest: '', vehicleClass: '', price: '' });
  const [isDeleteRouteModalOpen, setIsDeleteRouteModalOpen] = useState(false);
  const [routeToDelete, setRouteToDelete] = useState(null);

  const [formData, setFormData] = useState({
    sender: '', ktp: '', whatsapp: '', receiverName: '', receiverWhatsapp: '', receiverAddress: '', 
    vehicle: '', vehicleColor: '', vehiclePlate: '', vehicleYear: '', vehicleClass: '', vehicleNotes: '', 
    origin: '', dest: '', price: '', shipDate: '', insurance: false, doorToDoor: false
  });

  const handleInputChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleNumberChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value.replace(/[^0-9]/g, '') });
  const handleCheckboxChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.checked });

  const handleRouteInputChange = (e) => setRouteFormData({ ...routeFormData, [e.target.name]: e.target.value });
  const handleRoutePriceChange = (e) => setRouteFormData({ ...routeFormData, price: e.target.value.replace(/[^0-9]/g, '') });

  const saveRoute = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    let finalizedRoute = null;
    let actionType = '';

    if (routeFormData.id) {
      finalizedRoute = { ...routeFormData, price: Number(routeFormData.price) };
      actionType = 'updateRoute';
      setRouteList(routeList.map(r => r.id === routeFormData.id ? finalizedRoute : r));
    } else {
      const nextIdNum = routeList.length + 1;
      const formattedIdNum = nextIdNum < 10 ? `00${nextIdNum}` : nextIdNum < 100 ? `0${nextIdNum}` : nextIdNum;
      const newId = `RT-${formattedIdNum}`;
      finalizedRoute = { ...routeFormData, id: newId, price: Number(routeFormData.price) };
      actionType = 'addRoute';
      setRouteList([finalizedRoute, ...routeList]);
    }

    setIsRouteModalOpen(false);
    showToast("Memperbarui rute...");

    try {
      if (googleScriptUrl) {
        await requestSync(actionType, finalizedRoute);
        showToast("Rute golongan berhasil disimpan ke Google Sheets!", "success");
      }
    } catch (err) {
      showToast("Rute tersimpan lokal, namun gagal sinkron ke awan.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const openAddRouteModal = () => {
    setRouteFormData({ id: '', origin: '', dest: '', vehicleClass: '', price: '' });
    setIsRouteModalOpen(true);
  };
  const openEditRouteModal = (route) => {
    setRouteFormData({ ...route });
    setIsRouteModalOpen(true);
  };
  const openDeleteRouteModal = (route) => {
    setRouteToDelete(route);
    setIsDeleteRouteModalOpen(true);
  };
  const confirmDeleteRoute = async () => {
    if (routeToDelete) {
      setRouteList(routeList.filter(r => r.id !== routeToDelete.id));
      setIsDeleteRouteModalOpen(false);
      showToast("Menghapus rute...");
      
      try {
        if (googleScriptUrl) {
          await requestSync('deleteRoute', { id: routeToDelete.id });
          showToast("Rute berhasil dihapus dari Google Sheets!", "success");
        }
      } catch (err) {
        showToast("Rute dihapus lokal, namun gagal sinkron ke awan.", "error");
      } finally {
        setRouteToDelete(null);
      }
    }
  };

  // --- MASTER DATA CUSTOMER ---
  const openEditCustomerModal = (customer) => {
    setEditingCustomer({ ...customer });
    setIsEditCustomerModalOpen(true);
  };
  const handleEditCustomerChange = (e) => {
    const { name, value } = e.target;
    setEditingCustomer({ 
      ...editingCustomer, 
      [name]: (name === 'whatsapp' || name === 'ktp') ? value.replace(/[^0-9]/g, '') : value 
    });
  };
  
  const saveEditCustomer = async (e) => {
    e.preventDefault();
    const originalCustomer = customers.find(c => c.id === editingCustomer.id);
    setCustomers(customers.map(c => c.id === editingCustomer.id ? editingCustomer : c));
    if (originalCustomer) {
      setOrders(prevOrders => prevOrders.map(order => {
        if (order.sender === originalCustomer.name || order.whatsapp === originalCustomer.whatsapp) {
          return {
            ...order,
            sender: editingCustomer.name,
            whatsapp: editingCustomer.whatsapp,
            ktp: editingCustomer.ktp
          };
        }
        return order;
      }));
    }
    setIsEditCustomerModalOpen(false);
    showToast("Mengedit pelanggan...");

    try {
      if (googleScriptUrl) {
        await requestSync('updateCustomer', editingCustomer);
        showToast("Pelanggan tersinkronisasi ke Google Sheets!", "success");
      }
    } catch (err) {
      showToast("Data tersimpan lokal, gagal kirim ke awan.", "error");
    } finally {
      setEditingCustomer(null);
    }
  };
  
  const openDeleteCustomerModal = (customer) => {
    setCustomerToDelete(customer);
    setIsDeleteCustomerModalOpen(true);
  };
  const confirmDeleteCustomer = async () => {
    if (customerToDelete) {
      setCustomers(customers.filter(c => c.id !== customerToDelete.id));
      setIsDeleteCustomerModalOpen(false);
      showToast("Menghapus pelanggan...");

      try {
        if (googleScriptUrl) {
          await requestSync('deleteCustomer', { id: customerToDelete.id });
          showToast("Pelanggan terhapus di Google Sheets!", "success");
        }
      } catch (err) {
        showToast("Pelanggan terhapus lokal, gagal sinkron ke awan.", "error");
      } finally {
        setCustomerToDelete(null);
      }
    }
  };

  const basePorts = ["Tanjung Priok, Jakarta", "Tanjung Perak, Surabaya", "Soekarno-Hatta, Makassar", "Semayang, Balikpapan"];
  const ports = Array.from(new Set([
    ...basePorts,
    ...routeList.map(r => r.origin),
    ...routeList.map(r => r.dest)
  ])).filter(Boolean).sort();

  useEffect(() => {
    if (formData.origin && formData.dest && formData.vehicleClass) {
      if (formData.origin === formData.dest) {
        setFormData(prev => ({ ...prev, price: 0 }));
      } else {
        let calculatedPrice = 0;
        
        const foundRoute = routeList.find(r => 
          r.origin === formData.origin && 
          r.dest === formData.dest &&
          r.vehicleClass === formData.vehicleClass
        );

        if (foundRoute) {
          calculatedPrice = Number(foundRoute.price);
        } else {
          const basePrice = 3500000;
          const stringVar = formData.origin.charCodeAt(0) + formData.dest.charCodeAt(0);
          const lengthVar = Math.abs(formData.origin.length - formData.dest.length) * 100000;
          
          let classModifier = 1.0;
          if (formData.vehicleClass.includes("Golongan I")) classModifier = 0.15;
          else if (formData.vehicleClass.includes("Golongan II")) classModifier = 0.3;
          else if (formData.vehicleClass.includes("Golongan III")) classModifier = 0.5;
          else if (formData.vehicleClass.includes("Golongan IV")) classModifier = 1.0;
          else if (formData.vehicleClass.includes("Golongan V")) classModifier = 1.5;
          else if (formData.vehicleClass.includes("Golongan VI")) classModifier = 2.2;
          else if (formData.vehicleClass.includes("Golongan VII")) classModifier = 3.0;

          calculatedPrice = (basePrice + (stringVar * 10000) + lengthVar) * classModifier;
          calculatedPrice = Math.round(calculatedPrice / 50000) * 50000; 
        }
        
        if (formData.insurance) calculatedPrice += 300000;
        if (formData.doorToDoor) calculatedPrice += 500000;

        setFormData(prev => ({ ...prev, price: calculatedPrice }));
      }
    } else {
      setFormData(prev => ({ ...prev, price: '' }));
    }
  }, [formData.origin, formData.dest, formData.vehicleClass, formData.insurance, formData.doorToDoor, routeList]);

  const totalPendapatan = orders
    .filter(o => o.paymentStatus === 'Lunas')
    .reduce((sum, order) => sum + (Number(order.price) || 0), 0);
  const countBelum = orders.filter(o => o.paymentStatus === 'Belum').length;
  const countLunas = orders.filter(o => o.paymentStatus === 'Lunas').length;

  const stats = [
    { type: 'standard', label: 'Pendapatan Diterima (Lunas)', value: `Rp ${totalPendapatan.toLocaleString('id-ID')}`, increase: 'Akumulasi' },
    { type: 'payment', label: 'Status Pembayaran', lunas: countLunas, belum: countBelum },
    { type: 'standard', label: 'Total Pelanggan', value: customers.length.toString(), increase: 'Aktif' },
  ];

  const handleEntrySubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    showToast("Mengirim pesanan baru...", "info");

    const randomId = Math.floor(1000 + Math.random() * 9000);
    const newResi = `AO-2606-${randomId}`;
    
    const getCity = (port) => {
      if (!port) return 'XXX';
      const parts = port.split(', ');
      return parts.length > 1 ? parts[1].substring(0, 3).toUpperCase() : port.substring(0,3).toUpperCase();
    };

    const newOrder = {
      id: newResi,
      sender: formData.sender || 'Pelanggan Baru', 
      ktp: formData.ktp || '-', 
      whatsapp: formData.whatsapp || '-',
      receiverName: formData.receiverName || '-', 
      receiverWhatsapp: formData.receiverWhatsapp || '-', 
      receiverAddress: formData.receiverAddress || '-',
      vehicle: formData.vehicle || 'Kendaraan Baru', 
      vehicleColor: formData.vehicleColor || '-', 
      vehiclePlate: formData.vehiclePlate || '-', 
      vehicleYear: formData.vehicleYear || '-', 
      vehicleClass: formData.vehicleClass || '-', 
      vehicleNotes: formData.vehicleNotes || '-',
      origin: formData.origin, 
      dest: formData.dest, 
      route: `${getCity(formData.origin)} - ${getCity(formData.dest)}`,
      status: 'Menunggu', 
      entryDate: new Date().toISOString().split('T')[0], 
      shipDate: formData.shipDate,
      price: Number(formData.price) || 0, 
      insurance: formData.insurance, 
      doorToDoor: formData.doorToDoor, 
      notes: '', 
      paymentStatus: 'Belum'
    };
    
    setOrders([newOrder, ...orders]);

    if (formData.sender) {
      setCustomers(prevCusts => {
        const existingIndex = prevCusts.findIndex(c => c.name.toLowerCase() === formData.sender.toLowerCase() || (formData.whatsapp && c.whatsapp === formData.whatsapp));
        if (existingIndex > -1) {
          return prevCusts.map((c, i) => i === existingIndex ? { ...c, totalOrders: c.totalOrders + 1 } : c);
        } else {
          const nextIdNum = prevCusts.length + 1;
          const formattedIdNum = nextIdNum < 10 ? `00${nextIdNum}` : nextIdNum < 100 ? `0${nextIdNum}` : nextIdNum;
          const newCust = { id: `CUST-${formattedIdNum}`, name: formData.sender, ktp: formData.ktp || '-', whatsapp: formData.whatsapp || '-', totalOrders: 1 };
          return [...prevCusts, newCust];
        }
      });
    }

    try {
      if (googleScriptUrl) {
        await requestSync('addOrder', newOrder);
        showToast("Pesanan berhasil disinkronkan ke Google Sheets!", "success");
      } else {
        showToast("Pesanan berhasil disimpan di memori lokal.", "info");
      }
      setGeneratedResi(newResi);
      setSubmitSuccess(true);
      
      if (mainContentRef.current) {
        mainContentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } catch (err) {
      showToast("Pesanan disimpan lokal, gagal sinkron ke awan.", "error");
      setGeneratedResi(newResi);
      setSubmitSuccess(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setSubmitSuccess(false);
    setGeneratedResi('');
    setFormData({ sender: '', ktp: '', whatsapp: '', receiverName: '', receiverWhatsapp: '', receiverAddress: '', vehicle: '', vehicleColor: '', vehiclePlate: '', vehicleYear: '', vehicleClass: '', vehicleNotes: '', origin: '', dest: '', price: '', shipDate: '', insurance: false, doorToDoor: false });
  };

  const openEditModal = (order) => {
    setEditingOrder({ ...order });
    setIsEditModalOpen(true);
  };

  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setEditingOrder({ ...editingOrder, [name]: checked });
    } else if (name === 'whatsapp' || name === 'ktp' || name === 'receiverWhatsapp' || name === 'vehicleYear' || name === 'price') {
      setEditingOrder({ ...editingOrder, [name]: value.replace(/[^0-9]/g, '') });
    } else {
      setEditingOrder({ ...editingOrder, [name]: value });
    }
  };

  useEffect(() => {
    if (editingOrder && editingOrder.origin && editingOrder.dest && editingOrder.vehicleClass) {
      if (editingOrder.origin === editingOrder.dest) {
        if (editingOrder.price !== 0) setEditingOrder(prev => ({ ...prev, price: 0 }));
      } else {
        let calculatedPrice = 0;
        
        const foundRoute = routeList.find(r => 
          r.origin === editingOrder.origin && 
          r.dest === editingOrder.dest &&
          r.vehicleClass === editingOrder.vehicleClass
        );

        if (foundRoute) {
          calculatedPrice = Number(foundRoute.price);
        } else {
          const basePrice = 3500000;
          const stringVar = editingOrder.origin.charCodeAt(0) + editingOrder.dest.charCodeAt(0);
          const lengthVar = Math.abs(editingOrder.origin.length - editingOrder.dest.length) * 100000;
          
          let classModifier = 1.0;
          if (editingOrder.vehicleClass.includes("Golongan I")) classModifier = 0.15;
          else if (editingOrder.vehicleClass.includes("Golongan II")) classModifier = 0.3;
          else if (editingOrder.vehicleClass.includes("Golongan III")) classModifier = 0.5;
          else if (editingOrder.vehicleClass.includes("Golongan IV")) classModifier = 1.0;
          else if (editingOrder.vehicleClass.includes("Golongan V")) classModifier = 1.5;
          else if (editingOrder.vehicleClass.includes("Golongan VI")) classModifier = 2.2;
          else if (editingOrder.vehicleClass.includes("Golongan VII")) classModifier = 3.0;

          calculatedPrice = (basePrice + (stringVar * 10000) + lengthVar) * classModifier;
          calculatedPrice = Math.round(calculatedPrice / 50000) * 50000; 
        }
        
        if (editingOrder.insurance) calculatedPrice += 300000;
        if (editingOrder.doorToDoor) calculatedPrice += 500000;

        if (editingOrder.price !== calculatedPrice) {
          setEditingOrder(prev => ({ ...prev, price: calculatedPrice }));
        }
      }
    }
  }, [editingOrder?.origin, editingOrder?.dest, editingOrder?.vehicleClass, editingOrder?.insurance, editingOrder?.doorToDoor, routeList]);

  const saveEditOrder = async (e) => {
    e.preventDefault();
    const getCity = (port) => {
      if (!port) return 'XXX';
      const parts = port.split(', ');
      return parts.length > 1 ? parts[1].substring(0, 3).toUpperCase() : port.substring(0,3).toUpperCase();
    };
    
    const updatedRoute = `${getCity(editingOrder.origin)} - ${getCity(editingOrder.dest)}`;
    const finalizedOrder = { ...editingOrder, route: updatedRoute, price: Number(editingOrder.price) || 0 };
    
    const originalOrder = orders.find(o => o.id === editingOrder.id);
    const isSenderChanged = originalOrder && (
      originalOrder.sender !== finalizedOrder.sender ||
      originalOrder.whatsapp !== finalizedOrder.whatsapp ||
      originalOrder.ktp !== finalizedOrder.ktp
    );

    setOrders(prevOrders => prevOrders.map(order => {
      if (order.id === finalizedOrder.id) {
        return finalizedOrder;
      }
      if (isSenderChanged && (order.sender === originalOrder.sender || order.whatsapp === originalOrder.whatsapp)) {
        return {
          ...order,
          sender: finalizedOrder.sender,
          whatsapp: finalizedOrder.whatsapp,
          ktp: finalizedOrder.ktp
        };
      }
      return order;
    }));

    if (isSenderChanged) {
      setCustomers(prevCustomers => prevCustomers.map(cust => {
        if (cust.name === originalOrder.sender || cust.whatsapp === originalOrder.whatsapp) {
          return {
            ...cust,
            name: finalizedOrder.sender,
            whatsapp: finalizedOrder.whatsapp,
            ktp: finalizedOrder.ktp
          };
        }
        return cust;
      }));
    }

    setIsEditModalOpen(false);
    showToast("Memperbarui pesanan...");

    try {
      if (googleScriptUrl) {
        await requestSync('updateOrder', finalizedOrder);
        showToast("Perubahan pesanan berhasil disinkronkan ke Google Sheets!", "success");
      }
    } catch (err) {
      showToast("Data tersimpan lokal, namun gagal sinkron ke awan.", "error");
    } finally {
      setEditingOrder(null);
    }
  };

  const openDeleteModal = (order) => {
    setOrderToDelete(order);
    setIsDeleteModalOpen(true);
  };
  const confirmDeleteOrder = async () => {
    if (orderToDelete) {
      setOrders(orders.filter(order => order.id !== orderToDelete.id));
      setIsDeleteModalOpen(false);
      showToast("Menghapus pesanan...");

      try {
        if (googleScriptUrl) {
          await requestSync('deleteOrder', { id: orderToDelete.id });
          showToast("Pesanan berhasil dihapus dari Google Sheets!", "success");
        }
      } catch (err) {
        showToast("Pesanan dihapus secara lokal, namun gagal sinkron ke awan.", "error");
      } finally {
        setOrderToDelete(null);
      }
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    return new Date(dateStr).toLocaleDateString('id-ID', options);
  };

  const filteredOrders = orders.filter(order => {
    const query = searchQuery.toLowerCase();
    return (
      String(order.id || '').toLowerCase().includes(query) ||
      String(order.sender || '').toLowerCase().includes(query) ||
      String(order.status || '').toLowerCase().includes(query) ||
      String(order.vehicle || '').toLowerCase().includes(query) ||
      String(order.route || '').toLowerCase().includes(query)
    );
  });

  const filteredCustomers = customers.filter(cust => {
    const query = searchQuery.toLowerCase();
    return (
      String(cust.id || '').toLowerCase().includes(query) ||
      String(cust.name || '').toLowerCase().includes(query) ||
      String(cust.ktp || '').toLowerCase().includes(query) ||
      String(cust.whatsapp || '').toLowerCase().includes(query)
    );
  });

  const filteredRoutes = routeList.filter(r => {
    const query = searchQuery.toLowerCase();
    return (
      String(r.id || '').toLowerCase().includes(query) ||
      String(r.origin || '').toLowerCase().includes(query) ||
      String(r.dest || '').toLowerCase().includes(query) ||
      String(r.vehicleClass || '').toLowerCase().includes(query)
    );
  });

  const renderStatusBadge = (status) => {
    let bgClass = 'bg-slate-100 text-slate-700';
    let dotClass = 'bg-slate-500';

    if (status === 'Menunggu') { bgClass = 'bg-amber-100 text-amber-700'; dotClass = 'bg-amber-500'; } 
    else if (status === 'Proses Muat') { bgClass = 'bg-blue-100 text-blue-700'; dotClass = 'bg-blue-500'; } 
    else if (status === 'Dalam Perjalanan') { bgClass = 'bg-indigo-100 text-indigo-700'; dotClass = 'bg-indigo-500'; } 
    else if (status === 'Tiba di Tujuan') { bgClass = 'bg-purple-100 text-purple-700'; dotClass = 'bg-purple-500'; } 
    else if (status === 'Selesai') { bgClass = 'bg-emerald-100 text-emerald-700'; dotClass = 'bg-emerald-500'; }

    return (
      <span className={`px-2.5 py-1 rounded-full text-[11px] font-medium inline-flex items-center gap-1.5 ${bgClass}`}>
        <div className={`w-1.5 h-1.5 rounded-full ${dotClass}`}></div>{status}
      </span>
    );
  };

  const renderPaymentBadge = (status) => {
    if (status === 'Lunas') return <span className="font-bold text-emerald-600">Lunas</span>;
    return <span className="font-bold text-red-600">Belum</span>;
  };

  const handlePrintInvoice = (order) => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    
    const insuranceCost = order.insurance ? 300000 : 0;
    const doorToDoorCost = order.doorToDoor ? 500000 : 0;
    const basePrice = (Number(order.price) || 0) - insuranceCost - doorToDoorCost;

    const insuranceHtml = order.insurance ? '<tr><td class="label">Asuransi</td><td class="amount">' + insuranceCost.toLocaleString('id-ID') + '</td></tr>' : '';
    const doorToDoorHtml = order.doorToDoor ? '<tr><td class="label">Door to Door</td><td class="amount">' + doorToDoorCost.toLocaleString('id-ID') + '</td></tr>' : '';

    const htmlContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Invoice - ${order.id}</title>
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 40px; color: #333; line-height: 1.6; }
            .header { border-bottom: 2px solid #2563eb; padding-bottom: 20px; margin-bottom: 30px; display: flex; justify-content: space-between; align-items: flex-end; }
            .title { font-size: 28px; font-weight: bold; color: #1e3a8a; margin: 0; }
            .subtitle { font-size: 14px; color: #64748b; }
            .resi-box { text-align: right; }
            .resi-label { font-size: 12px; color: #64748b; text-transform: uppercase; letter-spacing: 1px; }
            .resi-number { font-size: 20px; font-weight: bold; color: #0f172a; margin-bottom: 4px; }
            .invoice-date { font-size: 12px; color: #64748b; }
            .customer-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 30px; margin-bottom: 30px; }
            .customer-section-title { font-size: 14px; font-weight: bold; color: #1e3a8a; border-bottom: 2px solid #e2e8f0; padding-bottom: 6px; margin-bottom: 12px; text-transform: uppercase; }
            .info-table { width: 100%; }
            .info-table td { padding: 4px 0; vertical-align: top; font-size: 10pt; }
            .info-table td:first-child { width: 95px; font-weight: 600; color: #475569; }
            .bordered-table { width: 100%; border-collapse: collapse; margin-bottom: 30px; font-size: 10pt; }
            .bordered-table th, .bordered-table td { border: 1px solid #cbd5e1; padding: 10px 14px; text-align: left; }
            .bordered-table th { background-color: #f1f5f9; color: #334155; font-weight: bold; }
            .cost-table { width: 100%; }
            .cost-table td.label { font-weight: 600; color: #475569; }
            .cost-table td.amount { text-align: right; min-width: 120px; }
            .cost-table tr.total th, .cost-table tr.total td { background-color: #eff6ff; font-size: 10pt; font-weight: bold; color: #1e3a8a; }
            .footer-contact { position: fixed; bottom: 2.5cm; left: 1.6cm; right: 1.6cm; text-align: center; font-size: 8pt; color: #64748b; border-top: 0.5pt solid #cbd5e1; padding-top: 8px; }
            .tnc-page { page-break-before: always; font-size: 9pt; margin-top: 3.5cm; color: #334155; }
            .tnc-title { font-weight: bold; font-size: 11pt; color: #1e3a8a; margin-bottom: 15px; text-align: center; }
            .tnc-list { padding-left: 20px; margin: 0; }
            .tnc-list li { margin-bottom: 8px; }
            .tnc-sublist { list-style-type: disc; padding-left: 20px; margin-top: 4px; margin-bottom: 4px; }
            @media print { @page { margin: 0; } body { margin: 1.6cm; margin-bottom: 4cm; } .no-print { display: none; } }
          </style>
        </head>
        <body>
          <div class="header">
            <div><h1 class="title">AntarOto</h1><div class="subtitle">Layanan Pengiriman Kendaraan Terpercaya</div></div>
            <div class="resi-box"><div class="resi-label">Nomor Resi / AWB</div><div class="resi-number">${order.id}</div><div class="invoice-date">Tanggal: <strong>${formatDate(order.entryDate)}</strong></div></div>
          </div>
          <div class="customer-grid">
            <div>
              <div class="customer-section-title">Data Pengirim</div>
              <table class="info-table"><tr><td>Nama</td><td>: ${order.sender || '-'}</td></tr><tr><td>No. Telp</td><td>: ${order.whatsapp || '-'}</td></tr></table>
            </div>
            <div>
              <div class="customer-section-title">Data Penerima</div>
              <table class="info-table"><tr><td>Nama</td><td>: ${order.receiverName || '-'}</td></tr><tr><td>No. Telp</td><td>: ${order.receiverWhatsapp || '-'}</td></tr><tr><td>Alamat</td><td>: ${order.receiverAddress || '-'}</td></tr></table>
            </div>
          </div>
          <table class="bordered-table"><thead><tr><th>Pelabuhan Asal</th><th>Pelabuhan Tujuan</th></tr></thead><tbody><tr><td>${order.origin || '-'}</td><td>${order.dest || '-'}</td></tr></tbody></table>
          <table class="bordered-table"><thead><tr><th>Merk & Model</th><th>Golongan</th><th>Warna</th><th>No. Polisi</th><th>Tahun</th><th>Catatan Fisik</th></tr></thead><tbody><tr><td>${order.vehicle || '-'}</td><td>${order.vehicleClass || '-'}</td><td>${order.vehicleColor || '-'}</td><td style="text-transform: uppercase;">${order.vehiclePlate || '-'}</td><td>${order.vehicleYear || '-'}</td><td>${order.vehicleNotes || '-'}</td></tr></tbody></table>
          <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-top: 30px;">
            <div style="border: 1px dashed #cbd5e1; padding: 15px; border-radius: 8px; background-color: #f8fafc; font-size: 10pt; max-width: 250px;">
              <div style="font-weight: bold; color: #1e3a8a; margin-bottom: 5px;">Informasi Pembayaran:</div>
              <div>Pembayaran dengan transfer bank:</div><div style="font-weight: bold; font-size: 11pt; margin: 4px 0;">BCA: 390-038-1777</div><div>Atas Nama: M. Taufik S.Kom</div>
            </div>
            <div style="width: 50%;">
              <table class="bordered-table cost-table" style="margin-bottom: 0;">
                <tbody>
                  <tr><td class="label">Biaya Pengiriman</td><td class="amount">${basePrice.toLocaleString('id-ID')}</td></tr>
                  ${insuranceHtml}
                  ${doorToDoorHtml}
                  <tr class="total"><td class="label">Total Biaya</td><td class="amount">${(Number(order.price) || 0).toLocaleString('id-ID')}</td></tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="footer-contact">Kontak: 0813-555-33802 &nbsp;|&nbsp; Email: antaroto.id@gmail.com &nbsp;|&nbsp; Alamat: Pelabuhan Soekarno-Hatta, Makassar</div>
          <div class="tnc-page">
            <div class="tnc-title">TERM & CONDITION PENGIRIMAN KENDARAAN<br>- AntarOto -</div>
            <ol class="tnc-list">
              <li>Kendaraan wajib dilengkapi dokumen yang sah, seperti STNK atau surat keterangan kepemilikan yang berlaku.</li>
              <li>BBM maksimal 1/4 tangki demi keamanan selama proses pengiriman.</li>
              <li>Barang pribadi berharga seperti uang, perhiasan, laptop, handphone, surat penting, dan dokumen berharga tidak diperkenankan ditinggalkan di dalam kendaraan.</li>
              <li>Pengirim wajib memastikan kendaraan dalam kondisi: <ul class="tnc-sublist"><li>Rem berfungsi normal</li><li>Ban dalam kondisi baik</li><li>Tidak mengalami kebocoran oli atau bahan bakar</li><li>Dapat dihidupkan dan dijalankan</li></ul></li>
              <li>Foto kondisi kendaraan akan dilakukan saat proses serah terima sebagai dokumentasi.</li>
              <li>Estimasi waktu pengiriman bersifat perkiraan dan dapat berubah karena kondisi cuaca, pelayaran, kemacetan, atau faktor operasional lainnya.</li>
              <li>Klaim kerusakan atau kehilangan wajib disampaikan maksimal 1 x 24 jam setelah kendaraan diterima dengan melampirkan bukti pendukung.</li>
              <li>Biaya pengiriman harus dilunasi sesuai kesepakatan sebelum kendaraan diberangkatkan.</li>
              <li>Dengan menyerahkan kendaraan kepada pihak ekspedisi, pelanggan dianggap telah menyetujui seluruh syarat dan ketentuan yang berlaku.</li>
            </ol>
          </div>
          <script>window.onload = function() { setTimeout(function() { window.print(); }, 300); }</script>
        </body>
      </html>
    `;
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  const copyScriptToClipboard = () => {
    navigator.clipboard.writeText(GOOGLE_APPS_SCRIPT_CODE);
    setIsCopiedScript(true);
    showToast("Kode Apps Script berhasil disalin!", "success");
    setTimeout(() => setIsCopiedScript(false), 2000);
  };

  if (!isAuthenticated) return <LoginScreen onLogin={handleLoginAttempt} externalError={loginError} />;

  return (
    <div className="flex h-screen bg-slate-50 font-sans text-slate-800 overflow-hidden relative pb-16 md:pb-0">
      
      {/* Toast Notification */}
      {toast && (
        <div className={`fixed top-4 right-4 z-[999] p-4 rounded-xl shadow-xl flex items-center gap-2.5 text-sm font-semibold transition-all animate-in slide-in-from-right-4 duration-300 ${
          toast.type === 'success' ? 'bg-emerald-600 text-white shadow-emerald-200' :
          toast.type === 'error' ? 'bg-red-600 text-white shadow-red-200' : 'bg-blue-600 text-white shadow-blue-200'
        }`}>
          <CheckCircle2 size={18} />
          {toast.message}
        </div>
      )}

      {/* Desktop Sidebar */}
      <aside className={`hidden md:flex flex-col inset-y-0 left-0 z-50 ${isSidebarCollapsed ? 'w-20' : 'w-64'} transition-all duration-300 ease-in-out bg-slate-900 text-slate-300 flex-shrink-0 shadow-2xl relative`}>
        
        {/* Toggle Collapse Button */}
        <button 
          onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          className="absolute -right-3 top-20 bg-blue-600 text-white rounded-full p-1 shadow-md hover:bg-blue-500 transition-colors z-50 border-2 border-slate-900"
          title={isSidebarCollapsed ? "Perbesar Sidebar" : "Perkecil Sidebar"}
        >
          {isSidebarCollapsed ? <ChevronRight size={14} strokeWidth={3} /> : <ChevronLeft size={14} strokeWidth={3} />}
        </button>

        <div className="h-16 md:h-20 flex items-center justify-center px-4 border-b border-slate-800 shrink-0">
          <div className="flex items-center w-full justify-center">
            <div className="bg-blue-600 p-1.5 md:p-2 rounded-lg text-white">
              <Ship size={20} strokeWidth={2.5} />
            </div>
            {!isSidebarCollapsed && (
              <div className="ml-3 transition-opacity duration-300">
                <span className="text-lg md:text-xl font-bold text-white block leading-tight">AntarOto</span>
                <span className="text-[9px] md:text-[10px] text-blue-400 font-semibold tracking-wider uppercase block">Admin Portal</span>
                <span className="text-[9px] md:text-[10px] text-slate-400 font-normal block mt-0.5">v1.0.0-beta</span>
              </div>
            )}
          </div>
        </div>

        <nav className="flex-1 py-6 px-3 space-y-2 overflow-y-auto custom-scrollbar">
          {!isSidebarCollapsed && <p className="px-3 text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Menu Utama</p>}
          
          <button 
            title={isSidebarCollapsed ? "Dashboard" : ""} 
            onClick={() => changeMenu('dashboard')} 
            className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl transition-all ${activeMenu === 'dashboard' ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/50' : 'hover:bg-slate-800 hover:text-white'} ${isSidebarCollapsed ? 'justify-center' : ''}`}
          >
            <LayoutDashboard size={20} className="shrink-0" />
            {!isSidebarCollapsed && <span className="font-medium text-sm whitespace-nowrap">Dashboard</span>}
          </button>
          
          <button 
            title={isSidebarCollapsed ? "Entry Pesanan Baru" : ""} 
            onClick={() => changeMenu('entry')} 
            className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl transition-all ${activeMenu === 'entry' ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/50' : 'hover:bg-slate-800 hover:text-white'} ${isSidebarCollapsed ? 'justify-center' : ''}`}
          >
            <FilePlus2 size={20} className="shrink-0" />
            {!isSidebarCollapsed && <span className="font-medium text-sm whitespace-nowrap">Entry Pesanan Baru</span>}
          </button>
          
          <button 
            title={isSidebarCollapsed ? "Update Pelacakan" : ""} 
            onClick={() => changeMenu('tracking')} 
            className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl transition-all ${activeMenu === 'tracking' ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/50' : 'hover:bg-slate-800 hover:text-white'} ${isSidebarCollapsed ? 'justify-center' : ''}`}
          >
            <PackageSearch size={20} className="shrink-0" />
            {!isSidebarCollapsed && <span className="font-medium text-sm whitespace-nowrap">Update Pelacakan</span>}
          </button>

          {currentUser?.role === 'Super Admin' && (
            <>
              {!isSidebarCollapsed && <p className="px-3 text-xs font-semibold text-slate-500 uppercase tracking-wider mt-8 mb-2">Master Data</p>}
              {isSidebarCollapsed && <div className="h-px bg-slate-800 my-4 mx-2"></div>}
              
              <button 
                title={isSidebarCollapsed ? "Data Pelanggan" : ""} 
                onClick={() => changeMenu('customers')} 
                className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl transition-all ${activeMenu === 'customers' ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/50' : 'hover:bg-slate-800 hover:text-white text-slate-400'} ${isSidebarCollapsed ? 'justify-center' : ''}`}
              >
                <Users size={20} className="shrink-0" />
                {!isSidebarCollapsed && <span className="font-medium text-sm whitespace-nowrap">Data Pelanggan</span>}
              </button>
              
              <button 
                title={isSidebarCollapsed ? "Data Rute" : ""} 
                onClick={() => changeMenu('routes')} 
                className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl transition-all ${activeMenu === 'routes' ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/50' : 'hover:bg-slate-800 hover:text-white text-slate-400'} ${isSidebarCollapsed ? 'justify-center' : ''}`}
              >
                <Route size={20} className="shrink-0" />
                {!isSidebarCollapsed && <span className="font-medium text-sm whitespace-nowrap">Data Rute & Golongan</span>}
              </button>
            </>
          )}
        </nav>

        <div className="p-3 border-t border-slate-800 shrink-0 space-y-2">
          {currentUser?.role === 'Super Admin' && (
            <button 
              onClick={() => changeMenu('settings')}
              title={isSidebarCollapsed ? "Pengaturan" : ""} 
              className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl hover:bg-slate-800 hover:text-white transition-all ${activeMenu === 'settings' ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/50' : 'text-slate-400'} ${isSidebarCollapsed ? 'justify-center' : ''}`}
            >
              <Settings size={20} className="shrink-0" />
              {!isSidebarCollapsed && <span className="font-medium text-sm whitespace-nowrap">Pengaturan</span>}
            </button>
          )}
          <button 
            title={isSidebarCollapsed ? "Keluar Sistem" : ""} 
            onClick={handleLogout} 
            className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl hover:bg-red-500/10 hover:text-red-500 transition-all text-slate-400 ${isSidebarCollapsed ? 'justify-center' : ''}`}
          >
            <LogOut size={20} className="shrink-0" />
            {!isSidebarCollapsed && <span className="font-medium text-sm whitespace-nowrap">Keluar Sistem</span>}
          </button>
        </div>
      </aside>

      {/* Mobile Bottom Navigation */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 flex items-center justify-between px-2 pb-safe shadow-[0_-4px_15px_rgba(0,0,0,0.03)] h-16">
        <button onClick={() => changeMenu('dashboard')} className={`flex-1 flex flex-col items-center justify-center h-full ${activeMenu === 'dashboard' ? 'text-blue-600' : 'text-slate-400 hover:text-slate-600'}`}>
          <LayoutDashboard size={20} className={activeMenu === 'dashboard' ? 'fill-blue-50' : ''} /><span className="text-[10px] font-semibold mt-1">Home</span>
        </button>
        <button onClick={() => changeMenu('entry')} className={`flex-1 flex flex-col items-center justify-center h-full ${activeMenu === 'entry' ? 'text-blue-600' : 'text-slate-400 hover:text-slate-600'}`}>
          <FilePlus2 size={20} className={activeMenu === 'entry' ? 'fill-blue-50' : ''} /><span className="text-[10px] font-semibold mt-1">Pesanan</span>
        </button>
        <button onClick={() => changeMenu('tracking')} className={`flex-1 flex flex-col items-center justify-center h-full ${activeMenu === 'tracking' ? 'text-blue-600' : 'text-slate-400 hover:text-slate-600'}`}>
          <PackageSearch size={20} className={activeMenu === 'tracking' ? 'fill-blue-50' : ''} /><span className="text-[10px] font-semibold mt-1">Lacak</span>
        </button>
        {currentUser?.role === 'Super Admin' && (
          <>
            <button onClick={() => changeMenu('customers')} className={`flex-1 flex flex-col items-center justify-center h-full ${activeMenu === 'customers' ? 'text-blue-600' : 'text-slate-400 hover:text-slate-600'}`}>
              <Users size={20} className={activeMenu === 'customers' ? 'fill-blue-50' : ''} /><span className="text-[10px] font-semibold mt-1">Pelanggan</span>
            </button>
            <button onClick={() => changeMenu('settings')} className={`flex-1 flex flex-col items-center justify-center h-full ${activeMenu === 'settings' ? 'text-blue-600' : 'text-slate-400 hover:text-slate-600'}`}>
              <Settings size={20} className={activeMenu === 'settings' ? 'fill-blue-50' : ''} /><span className="text-[10px] font-semibold mt-1">Seting</span>
            </button>
          </>
        )}
      </nav>

      {/* Main Content Area */}
      <main className="flex-1 flex flex-col min-w-0 overflow-hidden">
        
        {/* Header */}
        <header className="h-16 md:h-20 bg-white border-b border-slate-200 flex items-center justify-between px-4 md:px-8 flex-shrink-0 z-10 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="flex flex-col justify-center">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-extrabold text-blue-700 tracking-tight leading-none">AntarOto</span>
                
                {connectionStatus === 'online' ? (
                  <span className="hidden sm:inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span> Google Sheets
                  </span>
                ) : connectionStatus === 'connecting' ? (
                  <span className="hidden sm:inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800">
                    <RefreshCw size={10} className="animate-spin" /> Sinkronisasi...
                  </span>
                ) : (
                  <span className="hidden sm:inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-slate-100 text-slate-800">
                    Lokal (Luring)
                  </span>
                )}
              </div>
              <span className="text-[10px] md:text-[11px] text-slate-500 font-medium mt-1">Jasa Pengiriman Kendaraan Terpercaya</span>
            </div>
          </div>
          
          <div className="flex items-center gap-3 md:gap-6 shrink-0 ml-4">
            {googleScriptUrl && (
              <button 
                onClick={() => loadDataFromSheets(googleScriptUrl)} 
                disabled={isSyncing} 
                title="Tarik Data dari Google Sheet"
                className="p-2 text-slate-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all"
              >
                <RefreshCw size={18} className={isSyncing ? "animate-spin" : ""} />
              </button>
            )}
            <button onClick={handleLogout} title="Keluar Akun" className="relative p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all">
              <LogOut size={22} />
            </button>
            <div className="h-8 w-px bg-slate-200 hidden md:block"></div>
            <div className="flex items-center gap-2 md:gap-3 cursor-pointer group">
              <div className="text-right hidden md:block">
                <p className="text-sm font-semibold text-slate-700 group-hover:text-blue-600 transition-colors">{currentUser?.name || 'Admin'}</p>
                <p className="text-xs text-slate-500">{currentUser?.role || 'Sistem'}</p>
              </div>
              <UserCircle size={32} className="md:w-9 md:h-9 text-slate-400 group-hover:text-blue-600 transition-colors" />
            </div>
          </div>
        </header>

        {/* Scrollable Container Content */}
        <div ref={mainContentRef} className="flex-1 overflow-y-auto p-4 md:p-8 pb-24 md:pb-8 relative scroll-smooth bg-slate-50">
          
          {connectionStatus !== 'online' && (
            <div className="sm:hidden mb-4 bg-amber-50 border border-amber-200 text-amber-800 p-3 rounded-xl text-xs flex justify-between items-center">
              <span className="font-semibold flex items-center gap-1.5"><Info size={14} /> Berjalan di Mode Offline Lokal.</span>
              <button onClick={() => changeMenu('settings')} className="underline font-bold">Atur Sheets</button>
            </div>
          )}

          {activeMenu === 'entry' && (
            <div className="max-w-5xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500 pb-32 md:pb-0">
              <div className="mb-6 md:mb-8">
                <h1 className="text-xl md:text-2xl font-bold text-slate-900">Entry Pesanan Baru</h1>
                <p className="text-slate-500 text-sm mt-1">Masukkan detail pengiriman untuk membuat Resi baru.</p>
              </div>

              {submitSuccess ? (
                <div className="bg-white rounded-2xl shadow-sm border border-emerald-100 p-6 md:p-10 text-center animate-in zoom-in-95 duration-300">
                  <div className="w-16 h-16 md:w-20 md:h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                    <CheckCircle2 size={32} className="text-emerald-600 md:w-10 md:h-10" />
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-2">Pesanan Berhasil!</h2>
                  <p className="text-sm md:text-base text-slate-500 mb-6">Data pengiriman telah tersimpan di sistem.</p>
                  
                  <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 md:p-6 max-w-md mx-auto mb-8">
                    <p className="text-xs md:text-sm text-slate-500 font-medium uppercase tracking-wider mb-2">Nomor Resi / AWB</p>
                    <p className="text-2xl md:text-3xl font-mono font-bold text-blue-700">{generatedResi}</p>
                  </div>

                  <div className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4">
                    <button 
                      onClick={() => { const latestOrder = orders.find(o => o.id === generatedResi); if (latestOrder) handlePrintInvoice(latestOrder); }} 
                      className="w-full sm:w-auto bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 md:py-2.5 px-6 rounded-xl md:rounded-lg transition-colors flex items-center justify-center gap-2 shadow-md"
                    >
                      <Download size={18} /> Download PDF Invoice
                    </button>
                    <button onClick={resetForm} className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 md:py-2.5 px-6 rounded-xl md:rounded-lg transition-colors flex items-center justify-center gap-2 shadow-md">
                      <FilePlus2 size={18} /> Buat Pesanan Baru
                    </button>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleEntrySubmit} className="space-y-4 md:space-y-6 pb-8">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
                    
                    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                      <div className="px-4 md:px-6 py-3 md:py-4 border-b border-slate-100 bg-slate-50 flex items-center gap-2">
                        <Users size={18} className="text-blue-600" />
                        <h3 className="font-semibold text-slate-800 text-sm md:text-base">Informasi Pelanggan</h3>
                      </div>
                      <div className="p-4 md:p-6 space-y-5 md:space-y-6">
                        <div>
                          <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3">Data Pengirim</h4>
                          <div className="space-y-3 md:space-y-4">
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Nama Lengkap / Perusahaan *</label>
                              <input name="sender" value={formData.sender} onChange={handleInputChange} required type="text" className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base" placeholder="Contoh: Budi Santoso" />
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                              <div>
                                <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">No. WhatsApp *</label>
                                <input name="whatsapp" value={formData.whatsapp} onChange={handleNumberChange} required type="tel" className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base" placeholder="0812..." />
                              </div>
                              <div>
                                <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">No. Identitas KTP *</label>
                                <input name="ktp" value={formData.ktp} onChange={handleNumberChange} required type="text" maxLength={16} className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base" placeholder="16 Digit NIK KTP" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="border-t border-slate-100 my-1 md:my-2"></div>
                        <div>
                          <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3">Data Penerima</h4>
                          <div className="space-y-3 md:space-y-4">
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Nama Lengkap / Perusahaan *</label>
                              <input name="receiverName" value={formData.receiverName} onChange={handleInputChange} required type="text" className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base" placeholder="Contoh: Andi Wijaya" />
                            </div>
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">No. WhatsApp *</label>
                              <input name="receiverWhatsapp" value={formData.receiverWhatsapp} onChange={handleNumberChange} required type="tel" className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base" placeholder="0812..." />
                            </div>
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Alamat (Door to Door)</label>
                              <textarea name="receiverAddress" value={formData.receiverAddress} onChange={handleInputChange} rows={2} className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base resize-none" placeholder="Isi alamat lengkap..."></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-4 md:space-y-6">
                      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                        <div className="px-4 md:px-6 py-3 md:py-4 border-b border-slate-100 bg-slate-50 flex items-center gap-2">
                          <Car size={18} className="text-blue-600" />
                          <h3 className="font-semibold text-slate-800 text-sm md:text-base">Detail Kendaraan</h3>
                        </div>
                        <div className="p-4 md:p-6 space-y-3 md:space-y-4">
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Merk & Model *</label>
                              <input name="vehicle" value={formData.vehicle} onChange={handleInputChange} required type="text" className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base" placeholder="Cth: Toyota Fortuner" />
                            </div>
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Warna *</label>
                              <input name="vehicleColor" value={formData.vehicleColor} onChange={handleInputChange} required type="text" className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base" placeholder="Cth: Hitam" />
                            </div>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Nomor Polisi / STNK *</label>
                              <input name="vehiclePlate" value={formData.vehiclePlate} onChange={handleInputChange} required type="text" className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base font-mono uppercase" placeholder="B 1234 ABC" />
                            </div>
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Tahun Pembuatan</label>
                              <input name="vehicleYear" value={formData.vehicleYear} onChange={handleNumberChange} type="text" maxLength={4} className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base" placeholder="2022" />
                            </div>
                          </div>

                          {/* --- GOLONGAN KENDARAAN --- */}
                          <div>
                            <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Golongan Kendaraan *</label>
                            <select 
                              name="vehicleClass" 
                              value={formData.vehicleClass} 
                              onChange={handleInputChange} 
                              required 
                              className={`w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base ${formData.vehicleClass === '' ? 'text-slate-400' : 'text-slate-800'}`}
                            >
                              <option value="" disabled hidden>Pilih Golongan...</option>
                              <option value="Golongan I (Sepeda / Roda Dua Kecil)">Golongan I (Sepeda / Roda Dua Kecil)</option>
                              <option value="Golongan II (Sepeda Motor < 500cc)">Golongan II (Sepeda Motor &lt; 500cc)</option>
                              <option value="Golongan III (Sepeda Motor >= 500cc)">Golongan III (Sepeda Motor &gt;= 500cc)</option>
                              <option value="Golongan IV (Mobil Penumpang/Pribadi <= 5m)">Golongan IV (Mobil Penumpang/Pribadi &lt;= 5m)</option>
                              <option value="Golongan V (Truk/Bus Sedang <= 7m)">Golongan V (Truk/Bus Sedang &lt;= 7m)</option>
                              <option value="Golongan VI (Truk/Bus Besar <= 10m)">Golongan VI (Truk/Bus Besar &lt;= 10m)</option>
                              <option value="Golongan VII (Truk Tronton/Trailer > 10m)">Golongan VII (Truk Tronton/Trailer &gt; 10m)</option>
                            </select>
                          </div>

                          <div>
                            <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Catatan Fisik (Opsional)</label>
                            <input name="vehicleNotes" value={formData.vehicleNotes} onChange={handleInputChange} type="text" className="w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base" placeholder="Cth: Baret kecil di bumper depan" />
                          </div>
                        </div>
                      </div>

                      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                        <div className="px-4 md:px-6 py-3 md:py-4 border-b border-slate-100 bg-slate-50 flex items-center gap-2">
                          <MapPin size={18} className="text-blue-600" />
                          <h3 className="font-semibold text-slate-800 text-sm md:text-base">Rute & Biaya</h3>
                        </div>
                        <div className="p-4 md:p-6 space-y-3 md:space-y-4">
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Pelabuhan Asal *</label>
                              <select 
                                name="origin" 
                                value={formData.origin} 
                                onChange={handleInputChange} 
                                required 
                                className={`w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base ${formData.origin === '' ? 'text-slate-400' : 'text-slate-800'}`}
                              >
                                <option value="" disabled hidden>Pilih...</option>
                                {ports.map(p => <option key={`asal-${p}`} value={p} className="text-slate-800">{p}</option>)}
                              </select>
                            </div>
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Pelabuhan Tujuan *</label>
                              <select 
                                name="dest" 
                                value={formData.dest} 
                                onChange={handleInputChange} 
                                required 
                                className={`w-full p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base ${formData.dest === '' ? 'text-slate-400' : 'text-slate-800'}`}
                              >
                                <option value="" disabled hidden>Pilih...</option>
                                {ports.map(p => <option key={`tujuan-${p}`} value={p} className="text-slate-800">{p}</option>)}
                              </select>
                            </div>
                          </div>
                          
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Jadwal Kapal *</label>
                              <div className="relative">
                                <Calendar size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"/>
                                <input name="shipDate" value={formData.shipDate} onChange={handleInputChange} required type="date" className="w-full pl-10 p-3 md:p-2.5 bg-slate-50 border border-slate-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base" />
                              </div>
                            </div>
                            <div>
                              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1">Total Biaya (Rp) *</label>
                              <input 
                                required 
                                type="text" 
                                readOnly
                                value={formData.price ? Number(formData.price).toLocaleString('id-ID') : ''}
                                className="w-full p-3 md:p-2.5 bg-blue-50 border border-blue-200 rounded-xl md:rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm md:text-base font-bold text-blue-900 cursor-not-allowed" 
                                placeholder="0" 
                              />
                            </div>
                          </div>

                          <div className="pt-2 border-t border-slate-100 mt-2">
                            <label className="block text-xs md:text-sm font-medium text-slate-700 mb-3">Layanan Tambahan</label>
                            <div className="flex flex-col sm:flex-row gap-3 md:gap-6">
                              <label className="flex items-center gap-3 cursor-pointer group">
                                <div className="relative flex items-center justify-center">
                                  <input type="checkbox" name="insurance" checked={formData.insurance} onChange={handleCheckboxChange} className="peer appearance-none w-5 h-5 border-2 border-slate-300 rounded-md checked:bg-blue-600 checked:border-blue-600 transition-colors cursor-pointer" />
                                  <CheckCircle2 size={14} className="text-white absolute opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity" strokeWidth={3} />
                                </div>
                                <span className="text-sm font-medium text-slate-600 group-hover:text-slate-900 transition-colors">Asuransi</span>
                              </label>
                              <label className="flex items-center gap-3 cursor-pointer group">
                                <div className="relative flex items-center justify-center">
                                  <input type="checkbox" name="doorToDoor" checked={formData.doorToDoor} onChange={handleCheckboxChange} className="peer appearance-none w-5 h-5 border-2 border-slate-300 rounded-md checked:bg-blue-600 checked:border-blue-600 transition-colors cursor-pointer" />
                                  <CheckCircle2 size={14} className="text-white absolute opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity" strokeWidth={3} />
                                </div>
                                <span className="text-sm font-medium text-slate-600 group-hover:text-slate-900 transition-colors">Door to Door</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Wrapper khusus untuk tombol */}
                  <div className="fixed bottom-[4rem] md:bottom-auto left-0 right-0 md:static md:mt-6 bg-white p-4 md:p-6 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] md:shadow-sm border-t md:border border-slate-200 md:rounded-2xl z-30 flex items-center justify-between gap-3">
                    <button type="button" onClick={resetForm} className="hidden sm:block px-6 py-3 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">
                      Reset Form
                    </button>
                    <button 
                      type="submit" 
                      disabled={isSubmitting}
                      className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3.5 md:py-3 px-8 rounded-xl transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed text-base md:text-sm"
                    >
                      {isSubmitting ? 'Memproses...' : (
                        <>Simpan Pesanan <ArrowRight size={18} /></>
                      )}
                    </button>
                  </div>
                </form>
              )}
            </div>
          )}

          {activeMenu === 'dashboard' && (
            <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4 md:mb-6">
                <h1 className="text-xl md:text-2xl font-bold text-slate-900">Ringkasan Operasional</h1>
                
                <div className="w-full md:max-w-xs flex items-center bg-white rounded-full px-4 py-2 border border-slate-200 focus-within:ring-2 focus-within:ring-blue-500 transition-all shadow-sm">
                  <Search size={18} className="text-slate-400 shrink-0" />
                  <input 
                    type="text" 
                    placeholder="Cari resi, nama, status..." 
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="bg-transparent border-none outline-none ml-2 w-full text-sm text-slate-700 placeholder-slate-400"
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 md:mb-8">
                {stats.map((stat, idx) => (
                  <div key={idx} className="bg-white rounded-2xl p-5 shadow-sm border border-slate-200">
                    <p className="text-slate-500 text-sm font-medium mb-1">{stat.label}</p>
                    {stat.type === 'payment' ? (
                      <div className="flex items-center gap-5 mt-1">
                        <div className="flex flex-col">
                          <span className="text-2xl md:text-3xl font-bold text-emerald-600">{stat.lunas}</span>
                          <span className="text-[11px] font-semibold text-emerald-600/80 uppercase tracking-wider">Lunas</span>
                        </div>
                        <div className="h-8 w-px bg-slate-200"></div>
                        <div className="flex flex-col">
                          <span className="text-2xl md:text-3xl font-bold text-red-500">{stat.belum}</span>
                          <span className="text-[11px] font-semibold text-red-500/80 uppercase tracking-wider">Belum</span>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-end gap-3">
                        <h3 className="text-2xl md:text-3xl font-bold text-slate-900">{stat.value}</h3>
                        <span className={`text-xs font-medium mb-1 ${stat.increase.startsWith('+') ? 'text-emerald-500' : 'text-slate-400'}`}>
                          {stat.increase}
                        </span>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
                  <h3 className="font-semibold text-slate-800 text-base md:text-lg">Pesanan Terbaru</h3>
                  {orders.length === 0 && (
                    <button onClick={loadSimulationData} className="text-xs text-blue-600 hover:underline font-bold">
                      Gunakan Data Simulasi Lokal
                    </button>
                  )}
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm whitespace-nowrap">
                    <thead className="bg-slate-50 text-slate-500 uppercase tracking-wider text-[11px] md:text-xs">
                      <tr>
                        <th className="px-5 py-3 font-semibold">Resi / AWB</th>
                        <th className="px-5 py-3 font-semibold">Pengirim</th>
                        <th className="px-5 py-3 font-semibold">Kendaraan</th>
                        <th className="px-5 py-3 font-semibold">Rute</th>
                        <th className="px-5 py-3 font-semibold">Tgl Entry</th>
                        <th className="px-5 py-3 font-semibold">Jadwal Kapal</th>
                        <th className="px-5 py-3 font-semibold">Status</th>
                        <th className="px-5 py-3 font-semibold text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {filteredOrders.length > 0 ? (
                        filteredOrders.map((order, idx) => (
                          <tr key={idx} className="hover:bg-slate-50 transition-colors">
                            <td className="px-5 py-4 font-mono font-medium text-slate-900">{order.id}</td>
                            <td className="px-5 py-4 text-slate-700">{order.sender}</td>
                            <td className="px-5 py-4 text-slate-700">{order.vehicle}</td>
                            <td className="px-5 py-4 text-slate-700">{order.route}</td>
                            <td className="px-5 py-4 text-slate-700 whitespace-nowrap">{formatDate(order.entryDate)}</td>
                            <td className="px-5 py-4 text-slate-700 whitespace-nowrap">{formatDate(order.shipDate)}</td>
                            <td className="px-5 py-4">
                              {renderStatusBadge(order.status)}
                            </td>
                            <td className="px-5 py-4 text-center">
                              <button 
                                onClick={() => handlePrintInvoice(order)}
                                title="Cetak Ulang Invoice"
                                className="p-1.5 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors inline-flex items-center gap-1.5 font-medium text-xs"
                              >
                                <Printer size={15} /> Cetak
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} className="px-5 py-12 text-center text-slate-400">
                            {googleScriptUrl ? (
                              <span>Tidak ada pesanan ditemukan. Ketuk <strong className="text-blue-600 cursor-pointer" onClick={() => loadDataFromSheets(googleScriptUrl)}>Refresh</strong> atau buat pesanan baru.</span>
                            ) : (
                              <div className="space-y-2">
                                <p className="font-semibold text-slate-600">Database Kosong</p>
                                <p className="text-xs text-slate-400">Belum ada URL Google Sheets yang terhubung.</p>
                                <div className="flex justify-center gap-3 mt-4">
                                  <button onClick={loadSimulationData} className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-semibold rounded-lg transition-all">
                                    Simulasi Data Lokal
                                  </button>
                                  <button onClick={() => changeMenu('settings')} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold rounded-lg transition-all">
                                    Sambung Google Sheets
                                  </button>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {activeMenu === 'tracking' && (
            <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-4 md:mb-6">
                <div>
                  <h1 className="text-xl md:text-2xl font-bold text-slate-900">Update Pelacakan</h1>
                  <p className="text-slate-500 text-sm mt-1">Perbarui status lokasi pesanan secara real-time.</p>
                </div>

                <div className="w-full md:max-w-xs flex items-center bg-white rounded-full px-4 py-2 border border-slate-200 focus-within:ring-2 focus-within:ring-blue-500 transition-all shadow-sm">
                  <Search size={18} className="text-slate-400 shrink-0" />
                  <input 
                    type="text" 
                    placeholder="Cari resi, nama, status..." 
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="bg-transparent border-none outline-none ml-2 w-full text-sm text-slate-700 placeholder-slate-400"
                  />
                </div>
              </div>
              
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                <div className="px-5 py-4 border-b border-slate-200 bg-slate-50 flex justify-between items-center">
                  <h3 className="font-semibold text-slate-800 text-base">Daftar Status Pengiriman Aktif</h3>
                  {googleScriptUrl && (
                    <span className="text-xs font-semibold text-emerald-600 flex items-center gap-1">
                      <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span> 2-Way Sync Aktif
                    </span>
                  )}
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm whitespace-nowrap">
                    <thead className="bg-white text-slate-500 uppercase tracking-wider text-[11px] md:text-xs border-b border-slate-100">
                      <tr>
                        <th className="px-5 py-3 font-semibold">Resi / AWB</th>
                        <th className="px-5 py-3 font-semibold">Pengirim</th>
                        <th className="px-5 py-3 font-semibold">Rute</th>
                        <th className="px-5 py-3 font-semibold">Tgl Entry</th>
                        <th className="px-5 py-3 font-semibold">Jadwal Kapal</th>
                        <th className="px-5 py-3 font-semibold">Status</th>
                        <th className="px-5 py-3 font-semibold text-center">Pembayaran</th>
                        <th className="px-5 py-3 font-semibold">Catatan Tambahan</th>
                        <th className="px-5 py-3 font-semibold text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {filteredOrders.length > 0 ? (
                        filteredOrders.map((order, idx) => (
                          <tr key={idx} className="hover:bg-slate-50 transition-colors">
                            <td className="px-5 py-4 font-mono font-medium text-slate-900">{order.id}</td>
                            <td className="px-5 py-4 text-slate-700">
                              {order.sender}
                              <span className="block text-xs text-slate-400 mt-0.5">{order.vehicle}</span>
                            </td>
                            <td className="px-5 py-4 text-slate-700">{order.route}</td>
                            <td className="px-5 py-4 text-slate-700 whitespace-nowrap">{formatDate(order.entryDate)}</td>
                            <td className="px-5 py-4 text-slate-700 whitespace-nowrap">
                              <span className="inline-flex items-center gap-1.5"><Calendar size={14} className="text-slate-400"/> {formatDate(order.shipDate)}</span>
                            </td>
                            <td className="px-5 py-4">
                              {renderStatusBadge(order.status)}
                            </td>
                            <td className="px-5 py-4 text-center">
                              {renderPaymentBadge(order.paymentStatus)}
                            </td>
                            <td className="px-5 py-4">
                              <span className="text-xs text-slate-600 block max-w-[150px] truncate" title={order.notes}>
                                {order.notes || <span className="text-slate-400 italic">Tidak ada catatan</span>}
                              </span>
                            </td>
                            <td className="px-5 py-4 text-center">
                              <div className="flex items-center justify-center gap-1">
                                <button 
                                  onClick={() => handlePrintInvoice(order)}
                                  title="Cetak Invoice"
                                  className="p-2 text-slate-400 hover:bg-slate-100 hover:text-blue-600 rounded-lg transition-colors"
                                >
                                  <Printer size={16} />
                                </button>
                                <button 
                                  onClick={() => openEditModal(order)}
                                  title="Edit Data"
                                  className="p-2 text-slate-400 hover:bg-slate-100 hover:text-blue-600 rounded-lg transition-colors"
                                >
                                  <Edit size={16} />
                                </button>
                                <button 
                                  onClick={() => openDeleteModal(order)}
                                  title="Hapus Pesanan"
                                  className="p-2 text-slate-400 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors"
                                >
                                  <Trash2 size={16} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={9} className="px-5 py-8 text-center text-slate-500">
                            Belum ada pesanan terdaftar di sistem.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {activeMenu === 'customers' && (
            <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-4 md:mb-6">
                <div>
                  <h1 className="text-xl md:text-2xl font-bold text-slate-900">Database Pelanggan</h1>
                  <p className="text-slate-500 text-sm mt-1">Kelola data informasi detail pelanggan dan riwayat transaksi mereka.</p>
                </div>

                <div className="w-full md:max-w-xs flex items-center bg-white rounded-full px-4 py-2 border border-slate-200 focus-within:ring-2 focus-within:ring-blue-500 transition-all shadow-sm">
                  <Search size={18} className="text-slate-400 shrink-0" />
                  <input 
                    type="text" 
                    placeholder="Cari pelanggan, KTP, WA..." 
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="bg-transparent border-none outline-none ml-2 w-full text-sm text-slate-700 placeholder-slate-400"
                  />
                </div>
              </div>
              
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                <div className="px-5 py-4 border-b border-slate-200 bg-slate-50">
                  <h3 className="font-semibold text-slate-800 text-base">Daftar Pelanggan Terdaftar</h3>
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm whitespace-nowrap">
                    <thead className="bg-white text-slate-500 uppercase tracking-wider text-[11px] md:text-xs border-b border-slate-100">
                      <tr>
                        <th className="px-5 py-3 font-semibold">ID Pelanggan</th>
                        <th className="px-5 py-3 font-semibold">Nama Pelanggan</th>
                        <th className="px-5 py-3 font-semibold">No. KTP / Identitas</th>
                        <th className="px-5 py-3 font-semibold">No. WhatsApp</th>
                        <th className="px-5 py-3 font-semibold text-center">Total Kiriman</th>
                        <th className="px-5 py-3 font-semibold text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {filteredCustomers.length > 0 ? (
                        filteredCustomers.map((cust, idx) => (
                          <tr key={idx} className="hover:bg-slate-50 transition-colors">
                            <td className="px-5 py-4 font-mono font-medium text-slate-900">{cust.id}</td>
                            <td className="px-5 py-4 text-slate-900 font-semibold">{cust.name}</td>
                            <td className="px-5 py-4 text-slate-700">{cust.ktp}</td>
                            <td className="px-5 py-4 text-slate-700">{cust.whatsapp}</td>
                            <td className="px-5 py-4 text-center">
                              <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full font-bold text-xs inline-block">
                                {cust.totalOrders}x Kirim
                              </span>
                            </td>
                            <td className="px-5 py-4 text-center">
                              <div className="flex items-center justify-center gap-1">
                                <button 
                                  onClick={() => openEditCustomerModal(cust)}
                                  title="Edit Pelanggan"
                                  className="p-2 text-slate-400 hover:bg-slate-100 hover:text-blue-600 rounded-lg transition-colors"
                                >
                                  <Edit size={16} />
                                </button>
                                <button 
                                  onClick={() => openDeleteCustomerModal(cust)}
                                  title="Hapus Pelanggan"
                                  className="p-2 text-slate-400 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors"
                                >
                                  <Trash2 size={16} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="px-5 py-8 text-center text-slate-500">
                            Belum ada data pelanggan yang terdaftar.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {activeMenu === 'routes' && (
            <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-4 md:mb-6">
                <div>
                  <h1 className="text-xl md:text-2xl font-bold text-slate-900">Data Rute & Biaya (Multi-Tarif)</h1>
                  <p className="text-slate-500 text-sm mt-1">Kelola harga rute pelabuhan spesifik untuk setiap golongan kendaraan.</p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                  {googleScriptUrl && (
                    <button 
                      onClick={handleSeedStandardRoutes}
                      disabled={isSubmitting}
                      className="w-full md:w-auto bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-2 px-4 rounded-full transition-colors flex items-center justify-center gap-2 shadow-sm text-sm"
                      title="Suntikkan 84 rute standar otomatis ke Google Sheet Anda"
                    >
                      <RefreshCw size={16} className={isSubmitting ? "animate-spin" : ""} /> Inisialisasi 84 Tarif Golongan
                    </button>
                  )}
                  <button 
                    onClick={openAddRouteModal}
                    className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-full transition-colors flex items-center justify-center gap-2 shadow-sm text-sm"
                  >
                    <Plus size={18} /> Tambah Tarif Rute
                  </button>
                </div>
              </div>

              {/* Banner Penawaran Seeding saat Kosong */}
              {routeList.length === 0 && googleScriptUrl && (
                <div className="mb-6 bg-blue-50 border border-blue-200 rounded-2xl p-6 text-slate-800 animate-in zoom-in-95 duration-300">
                  <h3 className="font-bold text-lg text-blue-900 flex items-center gap-2 mb-2">
                    <Info size={20} className="text-blue-700" /> Database Tarif Rute Google Sheets Anda Kosong?
                  </h3>
                  <p className="text-sm text-slate-600 mb-4 max-w-3xl">
                    Sistem AntarOto telah didesain untuk mengenali klasifikasi penyeberangan berdasarkan 7 Golongan Kendaraan. Klik tombol di bawah ini untuk mengunggah otomatis 84 kombinasi rute & tarif standar pelayaran antarpulau ke Google Sheets Anda secara instan.
                  </p>
                  <button 
                    onClick={handleSeedStandardRoutes}
                    disabled={isSubmitting}
                    className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2.5 px-6 rounded-xl text-sm transition-all shadow-md inline-flex items-center gap-2"
                  >
                    {isSubmitting ? "Memproses..." : "Suntikkan 84 Tarif Standar Sekarang"}
                  </button>
                </div>
              )}
              
              <div className="flex justify-end mb-4">
                <div className="w-full md:max-w-xs flex items-center bg-white rounded-full px-4 py-2 border border-slate-200 focus-within:ring-2 focus-within:ring-blue-500 transition-all shadow-sm">
                  <Search size={18} className="text-slate-400 shrink-0" />
                  <input 
                    type="text" 
                    placeholder="Cari rute, pelabuhan, golongan..." 
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="bg-transparent border-none outline-none ml-2 w-full text-sm text-slate-700 placeholder-slate-400"
                  />
                </div>
              </div>

              <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                <div className="px-5 py-4 border-b border-slate-200 bg-slate-50">
                  <h3 className="font-semibold text-slate-800 text-base">Daftar Rute Golongan Aktif ({routeList.length} Rute)</h3>
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm whitespace-nowrap">
                    <thead className="bg-white text-slate-500 uppercase tracking-wider text-[11px] md:text-xs border-b border-slate-100">
                      <tr>
                        <th className="px-5 py-3 font-semibold">ID Rute</th>
                        <th className="px-5 py-3 font-semibold">Pelabuhan Asal</th>
                        <th className="px-5 py-3 font-semibold">Pelabuhan Tujuan</th>
                        <th className="px-5 py-3 font-semibold">Golongan Kendaraan</th>
                        <th className="px-5 py-3 font-semibold text-right">Harga Dasar (Rp)</th>
                        <th className="px-5 py-3 font-semibold text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {filteredRoutes.length > 0 ? (
                        filteredRoutes.map((route, idx) => (
                          <tr key={idx} className="hover:bg-slate-50 transition-colors">
                            <td className="px-5 py-4 font-mono font-medium text-slate-900">{route.id}</td>
                            <td className="px-5 py-4 text-slate-700">{route.origin}</td>
                            <td className="px-5 py-4 text-slate-700">{route.dest}</td>
                            <td className="px-5 py-4 text-slate-600 font-semibold">{route.vehicleClass || <span className="text-slate-400 italic">Semua Golongan</span>}</td>
                            <td className="px-5 py-4 text-slate-900 font-bold text-right">
                              {Number(route.price).toLocaleString('id-ID')}
                            </td>
                            <td className="px-5 py-4 text-center">
                              <div className="flex items-center justify-center gap-1">
                                <button 
                                  onClick={() => openEditRouteModal(route)}
                                  title="Edit Rute"
                                  className="p-2 text-slate-400 hover:bg-slate-100 hover:text-blue-600 rounded-lg transition-colors"
                                >
                                  <Edit size={16} />
                                </button>
                                <button 
                                  onClick={() => openDeleteRouteModal(route)}
                                  title="Hapus Rute"
                                  className="p-2 text-slate-400 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors"
                                >
                                  <Trash2 size={16} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="px-5 py-12 text-center text-slate-400">
                            {googleScriptUrl ? (
                              <span>Tidak ada tarif rute ditemukan di database. Gunakan tombol <strong className="text-emerald-600 cursor-pointer" onClick={handleSeedStandardRoutes}>Inisialisasi 84 Tarif Golongan</strong> di atas untuk mengisi otomatis.</span>
                            ) : (
                              <span>Belum ada master rute. Hubungkan Google Sheet Anda di Pengaturan.</span>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {activeMenu === 'settings' && (
            <div className="animate-in fade-in slide-in-from-bottom-4 duration-500 space-y-8">
              
              {/* GOOGLE SHEETS SINKRONISASI PANEL */}
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden max-w-4xl">
                <div className="px-5 py-4 border-b border-slate-200 bg-slate-50 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <RefreshCw size={18} className="text-blue-600" />
                    <h3 className="font-bold text-slate-800 text-base">Koneksi Database Google Sheets</h3>
                  </div>
                  {connectionStatus === 'online' && (
                    <span className="text-xs bg-emerald-100 text-emerald-800 font-bold px-2.5 py-1 rounded-full flex items-center gap-1">
                      <span className="w-2 h-2 bg-emerald-500 rounded-full"></span> Terhubung
                    </span>
                  )}
                </div>
                <div className="p-6 space-y-6">
                  <form onSubmit={saveUrlConfiguration} className="space-y-4">
                    <div>
                      <label className="block text-sm font-semibold text-slate-700 mb-1.5">
                        Google Apps Script Web App URL
                      </label>
                      <div className="flex flex-col sm:flex-row gap-3">
                        <input 
                          type="url"
                          placeholder="https://script.google.com/macros/s/.../exec"
                          value={tempUrlInput}
                          onChange={(e) => setTempUrlInput(e.target.value)}
                          className="flex-1 p-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-mono text-slate-700"
                        />
                        <button 
                          type="submit"
                          className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-6 py-3 rounded-xl transition-all shadow-sm text-sm whitespace-nowrap active:scale-[0.98]"
                        >
                          Simpan & Hubungkan
                        </button>
                      </div>
                      <p className="text-xs text-slate-500 mt-2">
                        Masukkan URL Web App hasil deploy Google Apps Script Anda untuk mengaktifkan sinkronisasi database 2 arah secara instan.
                      </p>
                    </div>
                  </form>

                  {/* Langkah-langkah penyebaran */}
                  <div className="bg-slate-50 rounded-xl p-5 border border-slate-200/60 text-xs text-slate-600 space-y-3.5">
                    <h4 className="font-bold text-slate-800 text-sm flex items-center gap-1">
                      <Info size={16} className="text-blue-600 shrink-0" /> Cara Menghubungkan Google Sheet Anda:
                    </h4>
                    <ol className="list-decimal pl-4 space-y-2.5">
                      <li>Buka Google Sheet baru di Google Drive Anda.</li>
                      <li>Pilih menu <strong className="text-slate-800">Ekstensi (Extensions)</strong> &gt; <strong className="text-slate-800">Apps Script</strong>.</li>
                      <li>Hapus semua kode bawaan, lalu salin dan tempelkan kode Apps Script yang disediakan di bawah ini.</li>
                      <li>Simpan script, lalu klik <strong className="text-slate-800">Terapkan (Deploy)</strong> &gt; <strong className="text-slate-800">Penerapan baru (New deployment)</strong>.</li>
                      <li>Klik ikon gir tipe penerapan, pilih <strong className="text-slate-800">Aplikasi web (Web app)</strong>.</li>
                      <li>Setel bagian <strong className="text-slate-800">Who has access (Siapa yang memiliki akses)</strong> menjadi <strong className="text-slate-800 text-red-600 font-bold">Anyone (Siapa saja)</strong>. Lalu klik Deploy.</li>
                      <li>Izinkan akses keamanan Google Anda, salin <strong className="text-slate-800">Web app URL</strong> yang dihasilkan, lalu tempelkan pada kolom di atas.</li>
                    </ol>
                  </div>

                  {/* KODE APPS SCRIPT YANG BISA DI SALIN */}
                  <div className="border border-slate-200 rounded-xl overflow-hidden">
                    <div className="bg-slate-100 px-4 py-2.5 flex items-center justify-between border-b border-slate-200">
                      <span className="text-xs font-bold text-slate-700">Kode Google Apps Script (google_apps_script.js)</span>
                      <button 
                        onClick={copyScriptToClipboard} 
                        className="bg-white hover:bg-slate-50 text-slate-700 text-xs font-bold py-1 px-2.5 rounded-lg border border-slate-300 flex items-center gap-1.5 transition-colors"
                      >
                        {isCopiedScript ? <ClipboardCheck size={14} className="text-emerald-600" /> : <Copy size={14} />}
                        {isCopiedScript ? "Tersalin!" : "Salin Kode"}
                      </button>
                    </div>
                    <pre className="p-4 bg-slate-900 text-slate-300 text-[10px] font-mono overflow-x-auto max-h-60 rounded-b-xl leading-relaxed select-all">
                      {GOOGLE_APPS_SCRIPT_CODE}
                    </pre>
                  </div>
                </div>
              </div>

              {/* DAFTAR USER PORTAL */}
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden max-w-4xl">
                <div className="px-5 py-4 border-b border-slate-200 bg-slate-50 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Shield size={18} className="text-blue-600" />
                    <h3 className="font-bold text-slate-800 text-base">Daftar Pengguna Login</h3>
                  </div>
                  <button 
                    onClick={openAddUserModal}
                    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-1.5 px-3.5 rounded-full text-xs transition-colors shadow-sm"
                  >
                    Tambah User
                  </button>
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm whitespace-nowrap">
                    <thead className="bg-white text-slate-500 uppercase tracking-wider text-[11px] md:text-xs border-b border-slate-100">
                      <tr>
                        <th className="px-5 py-3 font-semibold">ID Pengguna</th>
                        <th className="px-5 py-3 font-semibold">Nama Lengkap</th>
                        <th className="px-5 py-3 font-semibold">Username</th>
                        <th className="px-5 py-3 font-semibold">Hak Akses / Role</th>
                        <th className="px-5 py-3 font-semibold text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {usersList.map((user, idx) => (
                        <tr key={idx} className="hover:bg-slate-50 transition-colors">
                          <td className="px-5 py-4 font-mono font-medium text-slate-900">{user.id}</td>
                          <td className="px-5 py-4 text-slate-900 font-semibold">{user.name}</td>
                          <td className="px-5 py-4 text-slate-700">{user.username}</td>
                          <td className="px-5 py-4">
                            <span className={`px-2.5 py-1 rounded-full text-[11px] font-bold ${user.role === 'Super Admin' ? 'bg-purple-100 text-purple-700' : user.role === 'Admin Operasional' ? 'bg-blue-100 text-blue-700' : 'bg-slate-100 text-slate-700'}`}>
                              {user.role}
                            </span>
                          </td>
                          <td className="px-5 py-4 text-center">
                            <div className="flex items-center justify-center gap-1">
                              <button 
                                onClick={() => openEditUserModal(user)}
                                title="Edit Pengguna"
                                className="p-2 text-slate-400 hover:bg-slate-100 hover:text-blue-600 rounded-lg transition-colors"
                              >
                                <Edit size={16} />
                              </button>
                              {user.username !== 'admin' && (
                                <button 
                                  onClick={() => openDeleteUserModal(user)}
                                  title="Hapus Pengguna"
                                  className="p-2 text-slate-400 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors"
                                >
                                  <Trash2 size={16} />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

        </div>
      </main>

      {/* Modal Edit Pesanan Full Data */}
      {isEditModalOpen && editingOrder && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]">
            <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between bg-slate-50 shrink-0">
              <h3 className="font-bold text-lg text-slate-800 flex items-center gap-2">
                Edit Data Lengkap <span className="text-blue-600 font-mono text-base bg-blue-100 px-2 py-0.5 rounded-md">{editingOrder.id}</span>
              </h3>
              <button onClick={() => { setIsEditModalOpen(false); setEditingOrder(null); }} className="text-slate-400 hover:text-red-500 p-1">
                <X size={20} />
              </button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar flex-1 min-h-0 bg-slate-100">
              <form id="editForm" onSubmit={saveEditOrder} className="space-y-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  
                  {/* KOLOM KIRI: Data Pelanggan & Kendaraan */}
                  <div className="space-y-6">
                    
                    <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
                      <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 flex items-center gap-2"><UserCircle size={16}/> Data Pengirim</h4>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-xs font-medium text-slate-700 mb-1">Nama Pengirim *</label>
                          <input name="sender" value={editingOrder.sender} onChange={handleEditChange} required type="text" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-xs font-medium text-slate-700 mb-1">No. WhatsApp *</label>
                            <input name="whatsapp" value={editingOrder.whatsapp} onChange={handleEditChange} required type="tel" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-slate-700 mb-1">No. KTP</label>
                            <input name="ktp" value={editingOrder.ktp || ''} onChange={handleEditChange} type="text" maxLength={16} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
                      <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 flex items-center gap-2"><Users size={16}/> Data Penerima</h4>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-xs font-medium text-slate-700 mb-1">Nama Penerima *</label>
                          <input name="receiverName" value={editingOrder.receiverName || ''} onChange={handleEditChange} required type="text" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-slate-700 mb-1">No. WhatsApp *</label>
                          <input name="receiverWhatsapp" value={editingOrder.receiverWhatsapp || ''} onChange={handleEditChange} required type="tel" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-slate-700 mb-1">Alamat (Door to Door)</label>
                          <textarea name="receiverAddress" value={editingOrder.receiverAddress || ''} onChange={handleEditChange} rows={2} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
                      <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 flex items-center gap-2"><Car size={16}/> Detail Kendaraan</h4>
                      <div className="space-y-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-xs font-medium text-slate-700 mb-1">Merk & Model *</label>
                            <input name="vehicle" value={editingOrder.vehicle} onChange={handleEditChange} required type="text" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-slate-700 mb-1">Warna *</label>
                            <input name="vehicleColor" value={editingOrder.vehicleColor || ''} onChange={handleEditChange} required type="text" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-xs font-medium text-slate-700 mb-1">No. Polisi *</label>
                            <input name="vehiclePlate" value={editingOrder.vehiclePlate || ''} onChange={handleEditChange} required type="text" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 uppercase font-mono" />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-slate-700 mb-1">Tahun</label>
                            <input name="vehicleYear" value={editingOrder.vehicleYear || ''} onChange={handleEditChange} type="text" maxLength={4} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                          </div>
                        </div>

                        {/* --- GOLONGAN KENDARAAN PADA MODAL EDIT --- */}
                        <div>
                          <label className="block text-xs font-medium text-slate-700 mb-1">Golongan Kendaraan *</label>
                          <select 
                            name="vehicleClass" 
                            value={editingOrder.vehicleClass || ''} 
                            onChange={handleEditChange} 
                            required 
                            className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 text-slate-800"
                          >
                            <option value="" disabled hidden>Pilih Golongan...</option>
                            <option value="Golongan I (Sepeda / Roda Dua Kecil)">Golongan I (Sepeda / Roda Dua Kecil)</option>
                            <option value="Golongan II (Sepeda Motor < 500cc)">Golongan II (Sepeda Motor &lt; 500cc)</option>
                            <option value="Golongan III (Sepeda Motor >= 500cc)">Golongan III (Sepeda Motor &gt;= 500cc)</option>
                            <option value="Golongan IV (Mobil Penumpang/Pribadi <= 5m)">Golongan IV (Mobil Penumpang/Pribadi &lt;= 5m)</option>
                            <option value="Golongan V (Truk/Bus Sedang <= 7m)">Golongan V (Truk/Bus Sedang &lt;= 7m)</option>
                            <option value="Golongan VI (Truk/Bus Besar <= 10m)">Golongan VI (Truk/Bus Besar &lt;= 10m)</option>
                            <option value="Golongan VII (Truk Tronton/Trailer > 10m)">Golongan VII (Truk Tronton/Trailer &gt; 10m)</option>
                          </select>
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-slate-700 mb-1">Catatan Fisik (Opsional)</label>
                          <input name="vehicleNotes" value={editingOrder.vehicleNotes || ''} onChange={handleEditChange} type="text" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                      </div>
                    </div>

                  </div>

                  {/* KOLOM KANAN: Rute, Biaya & Status */}
                  <div className="space-y-6">
                    
                    <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
                      <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 flex items-center gap-2"><MapPin size={16}/> Rute & Biaya</h4>
                      <div className="space-y-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-xs font-medium text-slate-700 mb-1">Pelabuhan Asal *</label>
                            <select name="origin" value={editingOrder.origin || ''} onChange={handleEditChange} required className={`w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 ${editingOrder.origin === '' ? 'text-slate-400' : 'text-slate-800'}`}>
                              <option value="" disabled hidden>Pilih...</option>
                              {ports.map(p => <option key={`e-asal-${p}`} value={p} className="text-slate-800">{p}</option>)}
                            </select>
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-slate-700 mb-1">Pelabuhan Tujuan *</label>
                            <select name="dest" value={editingOrder.dest || ''} onChange={handleEditChange} required className={`w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 ${editingOrder.dest === '' ? 'text-slate-400' : 'text-slate-800'}`}>
                              <option value="" disabled hidden>Pilih...</option>
                              {ports.map(p => <option key={`e-tujuan-${p}`} value={p} className="text-slate-800">{p}</option>)}
                            </select>
                          </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-xs font-medium text-slate-700 mb-1">Jadwal Kapal *</label>
                            <input name="shipDate" value={editingOrder.shipDate || ''} onChange={handleEditChange} required type="date" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-slate-700 mb-1">Total Biaya (Rp) *</label>
                            <input readOnly type="text" value={editingOrder.price ? Number(editingOrder.price).toLocaleString('id-ID') : ''} className="w-full p-2.5 bg-blue-50 border border-blue-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 font-bold text-blue-900 cursor-not-allowed" />
                          </div>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-4 pt-3 border-t border-slate-100">
                          <label className="flex items-center gap-2 cursor-pointer">
                            <input type="checkbox" name="insurance" checked={editingOrder.insurance || false} onChange={handleEditChange} className="w-4 h-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500" />
                            <span className="text-sm font-medium text-slate-700">Asuransi (+300k)</span>
                          </label>
                          <label className="flex items-center gap-2 cursor-pointer">
                            <input type="checkbox" name="doorToDoor" checked={editingOrder.doorToDoor || false} onChange={handleEditChange} className="w-4 h-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500" />
                            <span className="text-sm font-medium text-slate-700">Door to Door (+500k)</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
                      <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 flex items-center gap-2"><Settings size={16}/> Update Operasional</h4>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-xs font-medium text-slate-700 mb-1">Status Pengiriman</label>
                          <select name="status" value={editingOrder.status || 'Menunggu'} onChange={handleEditChange} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 font-medium text-slate-800 appearance-none">
                            <option value="Menunggu">Menunggu</option>
                            <option value="Proses Muat">Proses Muat</option>
                            <option value="Dalam Perjalanan">Dalam Perjalanan</option>
                            <option value="Tiba di Tujuan">Tiba di Tujuan</option>
                            <option value="Selesai">Selesai</option>
                          </select>
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-slate-700 mb-1">Status Pembayaran</label>
                          <select name="paymentStatus" value={editingOrder.paymentStatus || 'Belum'} onChange={handleEditChange} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 font-medium text-slate-800 appearance-none">
                            <option value="Belum">Belum Lunas</option>
                            <option value="Lunas">Lunas</option>
                          </select>
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-slate-700 mb-1">Catatan Internal / Kendala</label>
                          <textarea name="notes" value={editingOrder.notes || ''} onChange={handleEditChange} rows={2} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 text-slate-800 resize-none" placeholder="Isi detail jika ada kendala di lapangan..."></textarea>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </form>
            </div>
            <div className="px-6 py-4 border-t border-slate-200 bg-white flex items-center justify-end gap-3 shrink-0">
              <button type="button" onClick={() => { setIsEditModalOpen(false); setEditingOrder(null); }} className="px-4 py-2.5 text-sm font-medium text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">Batal</button>
              <button type="submit" form="editForm" className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-6 rounded-lg transition-colors flex items-center justify-center gap-2 text-sm shadow-md">
                <Save size={16} /> Simpan Perubahan
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Konfirmasi Hapus Order */}
      {isDeleteModalOpen && orderToDelete && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden flex flex-col">
            <div className="p-6 text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <AlertCircle size={32} className="text-red-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Hapus Data Pesanan?</h3>
              <p className="text-sm text-slate-500 mb-6">
                Apakah Anda yakin ingin membatalkan dan menghapus pesanan dengan Resi <span className="font-bold text-slate-700">{orderToDelete.id}</span>? Tindakan ini tidak dapat dikembalikan.
              </p>
              <div className="flex gap-3">
                <button onClick={() => { setIsDeleteModalOpen(false); setOrderToDelete(null); }} className="flex-1 px-4 py-2.5 text-sm font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors">Batal</button>
                <button onClick={confirmDeleteOrder} className="flex-1 px-4 py-2.5 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-xl transition-colors shadow-md shadow-red-200">Ya, Hapus</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Edit Pelanggan */}
      {isEditCustomerModalOpen && editingCustomer && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]">
            <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between bg-slate-50 shrink-0">
              <h3 className="font-bold text-lg text-slate-800">Edit Data Pelanggan</h3>
              <button onClick={() => { setIsEditCustomerModalOpen(false); setEditingCustomer(null); }} className="text-slate-400 hover:text-red-500 p-1"><X size={20} /></button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar flex-1 min-h-0">
              <form id="editCustomerForm" onSubmit={saveEditCustomer} className="space-y-4">
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-1">Nama Pelanggan</label>
                  <input name="name" value={editingCustomer.name} onChange={handleEditCustomerChange} required type="text" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-1">No. WhatsApp</label>
                  <input name="whatsapp" value={editingCustomer.whatsapp} onChange={handleEditCustomerChange} required type="tel" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-1">No. KTP / Identitas</label>
                  <input name="ktp" value={editingCustomer.ktp} onChange={handleEditCustomerChange} required type="text" maxLength={16} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
              </form>
            </div>
            <div className="px-6 py-4 border-t border-slate-200 bg-slate-50 flex items-center justify-end gap-3 shrink-0">
              <button type="button" onClick={() => { setIsEditCustomerModalOpen(false); setEditingCustomer(null); }} className="px-4 py-2.5 text-sm font-medium text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">Batal</button>
              <button type="submit" form="editCustomerForm" className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-6 rounded-lg transition-colors flex items-center justify-center gap-2 text-sm shadow-md">
                <Save size={16} /> Simpan
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Konfirmasi Hapus Pelanggan */}
      {isDeleteCustomerModalOpen && customerToDelete && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden flex flex-col">
            <div className="p-6 text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <AlertCircle size={32} className="text-red-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Hapus Data Pelanggan?</h3>
              <p className="text-sm text-slate-500 mb-6">
                Apakah Anda yakin ingin menghapus pelanggan <span className="font-bold text-slate-700">{customerToDelete.name}</span> dari database? Data riwayat kiriman pelanggan tidak akan terhapus.
              </p>
              <div className="flex gap-3">
                <button onClick={() => { setIsDeleteCustomerModalOpen(false); setCustomerToDelete(null); }} className="flex-1 px-4 py-2.5 text-sm font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors">Batal</button>
                <button onClick={confirmDeleteCustomer} className="flex-1 px-4 py-2.5 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-xl transition-colors shadow-md shadow-red-200">Ya, Hapus</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Tambah/Edit Rute dengan Pemilihan Golongan */}
      {isRouteModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg overflow-hidden flex flex-col max-h-[90vh]">
            <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between bg-slate-50 shrink-0">
              <h3 className="font-bold text-lg text-slate-800">
                {routeFormData.id ? 'Edit Rute & Golongan' : 'Tambah Tarif Rute Baru'}
              </h3>
              <button onClick={() => { setIsRouteModalOpen(false); setRouteFormData({ id: '', origin: '', dest: '', vehicleClass: '', price: '' }); }} className="text-slate-400 hover:text-red-500 p-1"><X size={20} /></button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar flex-1 min-h-0">
              <form id="routeForm" onSubmit={saveRoute} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Pelabuhan Asal</label>
                    <input 
                      name="origin" 
                      value={routeFormData.origin} 
                      onChange={handleRouteInputChange} 
                      required 
                      list="ports-list"
                      placeholder="Ketik atau pilih pelabuhan..."
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Pelabuhan Tujuan</label>
                    <input 
                      name="dest" 
                      value={routeFormData.dest} 
                      onChange={handleRouteInputChange} 
                      required 
                      list="ports-list"
                      placeholder="Ketik atau pilih pelabuhan..."
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                {/* --- INPUT GOLONGAN PADA TAMBAH/EDIT RUTE --- */}
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-1">Golongan Kendaraan *</label>
                  <select 
                    name="vehicleClass" 
                    value={routeFormData.vehicleClass} 
                    onChange={handleRouteInputChange} 
                    required 
                    className={`w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 ${routeFormData.vehicleClass === '' ? 'text-slate-400' : 'text-slate-800'}`}
                  >
                    <option value="" disabled hidden>Pilih Golongan...</option>
                    <option value="Golongan I (Sepeda / Roda Dua Kecil)">Golongan I (Sepeda / Roda Dua Kecil)</option>
                    <option value="Golongan II (Sepeda Motor < 500cc)">Golongan II (Sepeda Motor &lt; 500cc)</option>
                    <option value="Golongan III (Sepeda Motor >= 500cc)">Golongan III (Sepeda Motor &gt;= 500cc)</option>
                    <option value="Golongan IV (Mobil Penumpang/Pribadi <= 5m)">Golongan IV (Mobil Penumpang/Pribadi &lt;= 5m)</option>
                    <option value="Golongan V (Truk/Bus Sedang <= 7m)">Golongan V (Truk/Bus Sedang &lt;= 7m)</option>
                    <option value="Golongan VI (Truk/Bus Besar <= 10m)">Golongan VI (Truk/Bus Besar &lt;= 10m)</option>
                    <option value="Golongan VII (Truk Tronton/Trailer > 10m)">Golongan VII (Truk Tronton/Trailer &gt; 10m)</option>
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-1">Harga Dasar (Rp)</label>
                  <input 
                    name="price" 
                    value={routeFormData.price} 
                    onChange={handleRoutePriceChange} 
                    required 
                    type="text" 
                    placeholder="Contoh: 3500000"
                    className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500 font-medium" 
                  />
                  <p className="text-[10px] text-slate-500 mt-1">Harga ini akan otomatis terpilih secara spesifik saat Anda membuat pesanan dengan pelabuhan asal, pelabuhan tujuan, dan golongan kendaraan yang cocok.</p>
                </div>
              </form>
            </div>
            <div className="px-6 py-4 border-t border-slate-200 bg-slate-50 flex items-center justify-end gap-3 shrink-0">
              <button type="button" onClick={() => { setIsRouteModalOpen(false); setRouteFormData({ id: '', origin: '', dest: '', vehicleClass: '', price: '' }); }} className="px-4 py-2.5 text-sm font-medium text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">Batal</button>
              <button type="submit" form="routeForm" className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-6 rounded-lg transition-colors flex items-center justify-center gap-2 text-sm shadow-md">
                <Save size={16} /> Simpan Rute
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Konfirmasi Hapus Rute */}
      {isDeleteRouteModalOpen && routeToDelete && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden flex flex-col">
            <div className="p-6 text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <AlertCircle size={32} className="text-red-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Hapus Data Rute?</h3>
              <p className="text-sm text-slate-500 mb-6">
                Yakin ingin menghapus rute <span className="font-bold text-slate-700">{routeToDelete.id}</span>?
              </p>
              <div className="flex gap-3">
                <button onClick={() => { setIsDeleteRouteModalOpen(false); setRouteToDelete(null); }} className="flex-1 px-4 py-2.5 text-sm font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors">Batal</button>
                <button onClick={confirmDeleteRoute} className="flex-1 px-4 py-2.5 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-xl transition-colors shadow-md shadow-red-200">Ya, Hapus</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Tambah/Edit Pengguna */}
      {isUserModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]">
            <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between bg-slate-50 shrink-0">
              <h3 className="font-bold text-lg text-slate-800">
                {userFormData.id ? 'Edit Data Pengguna' : 'Tambah Pengguna Baru'}
              </h3>
              <button onClick={() => { setIsUserModalOpen(false); setUserFormData({ id: '', username: '', password: '', name: '', role: 'Admin Operasional' }); }} className="text-slate-400 hover:text-red-500 p-1"><X size={20} /></button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar flex-1 min-h-0">
              <form id="userForm" onSubmit={saveUser} className="space-y-4">
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-1">Nama Lengkap</label>
                  <input name="name" value={userFormData.name} onChange={handleUserInputChange} required type="text" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" placeholder="Contoh: Budi Santoso" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-1">Username Login</label>
                  <input name="username" value={userFormData.username} onChange={handleUserInputChange} required type="text" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" placeholder="Username" disabled={userFormData.username === 'admin'} />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-1">Kata Sandi</label>
                  <input name="password" value={userFormData.password} onChange={handleUserInputChange} required type="text" className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" placeholder="Password" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-1">Hak Akses / Role</label>
                  <select name="role" value={userFormData.role} onChange={handleUserInputChange} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500" disabled={userFormData.username === 'admin'}>
                    <option value="Super Admin">Super Admin</option>
                    <option value="Admin Operasional">Admin Operasional</option>
                    <option value="Staff Lapangan">Staff Lapangan</option>
                  </select>
                </div>
              </form>
            </div>
            <div className="px-6 py-4 border-t border-slate-200 bg-slate-50 flex items-center justify-end gap-3 shrink-0">
              <button type="button" onClick={() => { setIsUserModalOpen(false); setUserFormData({ id: '', username: '', password: '', name: '', role: 'Admin Operasional' }); }} className="px-4 py-2.5 text-sm font-medium text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">Batal</button>
              <button type="submit" form="userForm" className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-6 rounded-lg transition-colors flex items-center justify-center gap-2 text-sm shadow-md">
                <Save size={16} /> Simpan
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Konfirmasi Hapus Pengguna */}
      {isDeleteUserModalOpen && userToDelete && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden flex flex-col">
            <div className="p-6 text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <AlertCircle size={32} className="text-red-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Hapus Pengguna?</h3>
              <p className="text-sm text-slate-500 mb-6">
                Yakin ingin menghapus akses login untuk <span className="font-bold text-slate-700">{userToDelete.name}</span>?
              </p>
              <div className="flex gap-3">
                <button onClick={() => { setIsDeleteUserModalOpen(false); setUserToDelete(null); }} className="flex-1 px-4 py-2.5 text-sm font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors">Batal</button>
                <button onClick={confirmDeleteUser} className="flex-1 px-4 py-2.5 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-xl transition-colors shadow-md shadow-red-200">Ya, Hapus</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Datalist untuk Autocomplete Pelabuhan */}
      <datalist id="ports-list">
        {ports.map(p => <option key={`dl-${p}`} value={p} />)}
      </datalist>

    </div>
  );
};

export default App;